import zhCN from 'iview/dist/locale/zh-CN';

const cn = {
  info1: '已是第一个',
  info2: '已是最后一个',
  info03: '您即将删除所有关于此人的信息，您确定要删除吗？',
  info04: '暂无数据',
  info05: '点击下载',
  info06: '提交数据',
  info07: '低',
  info08: '中',
  info09: '高',
  info10: '极好',
  info11: '邮箱修改出错',
  info12: '主题',
  info13: '日期',
  info14: '切换密码验证',
  info15: '文件类型有误',
  info16: '重置',
  info17: 'HR智能体',
  info18: '2175云 – 专业的人力资源SAAS云平台',
  info19: '您确定要退出系统吗？',
  info20: '运行中',
  info21: '你确定要删除选择的消息吗？',
  info22: '您已成功绑定邮箱！',
  info23: '您需要为入职申请填写工号，请逐条处理入职申请！',
  info24: '是',
  info25: '否',
  info26: '员工自助',
  info27: '认证时间',
  info28: '认证方式',
  info29: '认证编号',
  info30: '认证账号',
  info31: '印章',
  info32: '员工认证方式',
  info33: '电子合同',
  info34: '认证',
  info35: '清空',
  info36: '验证方式',
  info37: '已完成',
  info38: '进行中',
  info39: '签署账户',
  info40: '印章',
  info41: '组织机构名称',
  info42: '组织机构代码',
  info43: '法人姓名',
  info44: '法人证件号',
  info45: '总行名称',
  info46: '省份名称',
  info47: '城市名称',
  info48: '开户行',
  info49: '银行四要素验证',
  info50: '运营商三要素验证',
  info51: '打款金额',
  info52: '注册类型',
  info53: '企业注册类型',
  info54: '单位类型',
  info55: '代理人注册',
  info56: '法人注册',
  info57: '普通企业',
  info58: '社会团体',
  info59: '事业单位',
  info60: '民办非企业单位',
  info61: '党政及国家机构',
  info62: '组织机构代码号',
  info63: '三证合一',
  info64: '企业工商注册码',
  info65: '签署备注',
  info66: '合同模板',
  info67: '完整比对',
  info68: '工商信息两要素比对',
  info69: '公司名称',
  info70: '请填写完整开户行信息',
  info71: '菜单',
  info72: '员工没有开通登录账户，无法发送问候！',
  info73: '请先完成公司认证！',
  info74: '数据中存在多个公司，无法进行批量签署！',
  info75: '名称',
  info76: '排序',
  info77: '有效',
  info78: '语言',
  info79: '中文',
  info80: '英文',
  info81: '没有查询到匹配的数据！',
  info82: '批量签署',
  info83: '当前为最后一条查询数据！',
  info84: '定时任务',
  info85: '周期',
  info86: '提前天数',
  info87: '汇率',
  info88: '货币',
  info89: '只读',
  info90: '读写',
  info91: '批量处理',
  info92: '总人数',
  info93: '填写完成',
  info94: '工作中',
  info95: '休息中',
  info96: '请假中',
  info97: '出差中',
  info98: '外出中',
  info99: '加班中',
  info100: '请选择',
  info101: '明细',
  info102: '扣除配额：',
  info103: '类型',
  loginTitle: '为人才提供专业的服务',
  display_password: '显示密码',
  hidden_password: '隐藏密码',
  fullscreenMax: '最大化',
  fullscreenMin: '正常',
  aboutUs: '关于我们',
  callUs: '联系我们',
  select: '全选',
  cancelSelect: '取消全选',
  termsOfService: '服务条款',
  copyright: '版权所有',
  right: '',
  company: '苏州路卡信息科技有限公司',
  close: '关闭',
  export: '导出',
  print: '打印',
  identyDiscern: '身份证识别',
  idPhoto: '证件照',
  title01: '我的应用',
  title02: '我的消息',
  title03: '联系我们',
  title04: '请用手机扫一扫',
  title05: '重置密码链接已发送至邮箱，请进入邮箱重置密码。',
  title06: '用户协议',
  title07: '我已仔细阅读用户协议',
  title08: '上传背景',
  title09: '代理中',
  title10: '设置代理',
  title11: '您确定要删除吗？',
  title12: '提示',
  title13: '取消代理',
  title14: '选择用户',
  title15: '选择菜单',
  title16: '授权周期',
  title17: '开始时间',
  title18: '结束时间',
  title19: '查询',
  title20: '代理人',
  title21: '未读',
  title22: '已读',
  title23: '个人信息',
  title24: '组织关系',
  title25: '地址',
  title26: '支付信息',
  title27: '选项',
  title28: '代理',
  title29: '引导',
  title30: '帮助',
  title31: '注销',
  title32: '您确定要复制吗？',
  title33: '新增',
  title34: '修改',
  title35: '复制',
  title36: '删除',
  title37: '男',
  title38: '女',
  title39: '基本工资',
  title40: '周期薪资',
  title41: '临时薪资',
  title42: '保存',
  title43: '绑定设备',
  title44: '解绑设备',
  title45: '设为已读消息',
  title46: '设为未读消息',
  title047: '恢复本人',
  title47: '确认创建用户？',
  title48: '导出',
  title49: '您确定要取消代理吗？',
  title50: '提醒',
  title51: '资料',
  title52: '暂停',
  title53: '处理中',
  title54: '查看',
  title55: '重新启动',
  title56: '同意',
  title57: '拒绝',
  title58: '申请',
  title59: '打卡',
  title60: '提交申请',
  title61: '签署',
  title62: '问候',
  title63: '验证',
  title64: '修改',
  title65: '上一个',
  title66: '下一个',
  title67: '单次',
  title68: '长期',
  title69: '岗位清单',
  title70: '验证用户',
  title71: '重置密码',
  title72: '欢迎登录2175云平台',
  title73: '设置',
  title74: '2175云管理平台',
  title75: '设置',
  title76: '修改头像',
  title77: '主题背景',
  title78: '基本资料',
  title79: '修改邮箱',
  title80: '修改手机号',
  title81: '已将重置邮箱链接发送到您的邮箱，请点击链接修改邮箱。',
  title82: '新增代理',
  title83: '高级查询',
  title84: '安全设置',
  title85: '您当前的账号安全程度',
  title86: '安全程度：',
  title87: '登录密码',
  title88:
    '安全性高的密码可以使帐号更安全。建议您定期更换密码，设置一个包含大写字母、小写字母、数字和特殊字符中至少三项且长度超过6位的密码。',
  title89: '邮箱绑定',
  title90: '您还未绑定邮箱，请先绑定邮箱号',
  title91: '手机绑定',
  title92: '您已绑定了手机',
  title93: '[ 手机号可以用来重置密码、接受系统通知 ]',
  title94: '您还未绑定手机，请先绑定手机号',
  title95: '设置',
  title96: '基本设置',
  title97: '验证码发送成功，请查看手机短信！',
  title98: '最多选择10个！',
  title102: '通知方式修改成功',
  title103: '修改通知方式',
  title101: '验证失败',
  title99: '全部展开',
  title100: '全部收起',
  title104: '没有附件',
  title105: '总额',
  title106: '关键岗位',
  title107: '查看员工信息',
  title108: '查看HRBP信息',
  title109: '首页',
  title110: '尾页',
  title111: '打开上级',
  title112: '收起上级',
  title113: '返回',
  title114: '员工关怀',
  title115: '入职祝福',
  title116: '生日祝福',
  title117: '您已绑定了邮箱',
  title118: '[ 邮箱可以用来重置密码、接受系统通知 ]',
  title119: '重置邮箱链接已发送至邮箱，请进入邮箱确认。',
  title120: '主数据',
  title121: '系统消息通知方式不能取消！',
  title122:
    '员工工资信息属于公司保密范畴，因此，请不要在任何场合和你的同事商谈或讨论，如有问题，请联系人事部，谢谢！',
  title123: '验证密码',
  title124: '月薪资明细',
  title125: '启动页',
  title126: '待审核',
  title127: '审批意见',
  title128: '申请详情',
  title129: '审批流程',
  title130: '附件',
  title131: '已审核',
  title132: '审批时间',
  title133: '暂无附件！',
  title134: '标准报表',
  title135: '自助报表',
  title136: '运行',
  title137: '下载',
  title138: '查看资料',
  title139: '暂停流程',
  title140: '启动流程',
  title141: '发起人',
  title142: '当前页面为必填信息类型！',
  title143: '进入',
  title144: '员工多维度数据分析报表',
  title145: '组织信息数据分析报表',
  title146: '用户轨迹数据分析报表',
  title147: '修改前',
  title148: '修改后',
  title149: '国家',
  title150: '省',
  title151: '权限设置',
  title152: '本人权限',
  title153: '允许',
  title154: '不重叠',
  title155: '仅一条',
  title156: '核心数据',
  title157: '自动',
  title158: '手动',
  title159: '数据已保存',
  title160: '筛选',
  title161: '这是一张报表',
  title162: '组织关系百分比总和超出100！',
  title163: '排班',
  title164: '个人OKR',
  title165: '协助OKR',
  title166: '企业智脑',
  title167: '薪资计算',
  title168: '算薪',
  title169: '算薪结果',
  title170: '用于通过网银支付薪资时，上传网银网站的数据报表',
  title171: '批量查看导出员工薪资项明细数据报表',
  title172: '天',
  title173: '请选择开始时间和结束时间',
  title174: '评估结果',
  title175: '导入完成！',
  title176: '停用',
  title177: '启用',
  title178: '签署',
  title179: '填写、签署',
  title180: 'HR',
  title181: '已',
  title182: '未',
  title183: '请填写完整',
  title184: '填写',
  title185: '不可为自己申请合同签署',
  title186: '未认证',
  title187: '查询未认证员工',
  title188: '提示您提交的文件格式错误，请提交Excel文件格式，具体格式详见模板',
  title189: '已取消',
  title190: '停用',
  title191: '启用',
  title192: '已拒绝',
  title193: '计件工资',
  title194: '作业量',
  title195: '默认支付账户',
  title196: '欢迎登录',
  title197: '平台',
  title198: '暂借款申请',
  title199: '费用预算申请',
  title200: '固定资产转移',
  title201: '请购单',
  title202: '电脑请购单',
  title203: '签呈',
  title204: '员工数据',
  title205: '员工考勤',
  title206: '移动',
  title207: '过滤过期数据',
  title208: '显示全部数据',
  title209: '固定工资总和',
  title210: '过滤已读信息',
  title211: '显示全部信息',
  title222: '手机登录',
  title223: '工作计划排班',
  title224: '名片申请',
  title225: '机票申请',
  title226: '签证申请',
  title227: '酒店申请',
  title228: '快递申请',
  title229: '访客登记单',
  title230: '行政报修单',
  title231: '转签',
  title232: '已发送旧邮箱验证码，请查验',
  title233: '岗位分配清单',
  title234: '您确定要删除所选的数据吗？',
  title235: '核薪单',
  title236: '周六工资',
  title237: '绩效津贴',
  title238: '技能津贴',
  title239: '岗位津贴',
  title240: '通讯补贴',
  title241: '住房补贴',
  title242: '全勤奖',
  title243: '小计',
  title244: '已选角色',
  title245: '导入类型',
  title246: '企业微信登录',
  title247: '钉钉登录',
  title248: '飞书登录',
  title249: '微信登录',
  title250: '微信绑定',
  title251: '您已绑定了微信',
  title252: '[ 可以使用微信扫码登录系统 ]',
  title253: '您还未绑定微信，请先绑定微信',
  title254: '使用微信扫一扫绑定2175',
  title255: '企业微信绑定',
  title256: '您已绑定了企业微信',
  title257: '[ 可以使用企业微信扫码登录系统 ]',
  title258: '您还未绑定企业微信，请先绑定企业微信',
  title259: '使用企业微信扫一扫绑定2175',
  title260: '钉钉绑定',
  title261: '您已绑定了钉钉',
  title262: '[ 可以使用钉钉扫码登录系统 ]',
  title263: '您还未绑定钉钉，请先绑定钉钉',
  title264: '使用钉钉扫一扫绑定2175',
  title265: '飞书绑定',
  title266: '您已绑定了飞书',
  title267: '[ 可以使用飞书扫码登录系统 ]',
  title268: '您还未绑定飞书，请先绑定飞书',
  title269: '使用飞书扫一扫绑定2175',
  title270: '解绑',
  title271: '微信解绑',
  title272: '企业微信解绑',
  title273: '钉钉解绑',
  title274: '飞书解绑',
  title275: '信息类型字段',
  title276: '使用飞书扫一扫登录',
  title277: '吐槽',
  title278: '2175云',
  title279: '快速入门',
  title280: '浏览快速入门，立马了解系统？',
  title281: '任务类型',
  title282: '未归档',
  title283: '已归档',
  title284: '归档人',
  title285: '归档时间',
  title286: '浏览记录',
  title287: '文件上传',
  title288: '上传文件夹',
  title289: '任务日报',
  title300: '项目',
  title301: '任务',
  title302: '项目数据',
  button01: '登录',
  button02: '忘记密码',
  button03: '确定',
  button04: '今天',
  button05: '昨天',
  button06: '一周前',
  button07: '查询',
  button08: '异动',
  button09: '录用',
  button10: '转岗',
  button11: '离职',
  button12: '重新录用',
  button13: '创建用户',
  button14: '导入照片',
  button15: '批量操作',
  button16: '批量导入',
  button17: '批量修改',
  button18: '模板下载',
  button19: '本周',
  button20: '本月',
  button21: '本季',
  button22: '今年',
  button23: '取消',
  button24: '点击上传',
  button25: '班车申请',
  button26: '切换手机验证',
  button27: '切换邮箱验证',
  button28: '获取验证码',
  button29: '返回首页',
  button30: '重新发送',
  button31: '去年',
  button32: '启动',
  button33: '运行',
  button34: '确认',
  button35: '发起签约',
  button36: '提交',
  button37: '退回',
  button38: '确认',
  button39: '发函',
  button40: '生效',
  button41: '公共假日',
  button42: '班次类型',
  button43: '休息',
  button44: '班次',
  button45: '假期类型',
  button46: '配额类型',
  button47: '不用了',
  button48: '进入',
  button49: '离职',
  button50: '催办',
  btnRefresh: '刷新',
  btnAdd: '新增',
  btnSearch: '查找',
  btnDel: '删除',
  btnCopy: '复制',
  btnEdit: '修改',
  costType: '费用类型',
  btnDown: '下载模板',
  btnImport: '批量导入',
  btnUploadFile: '上传文件',
  btnNewFolder: '新建文件夹',
  label01: '原密码',
  label02: '新密码',
  label03: '重复新密码',
  label04: '系统消息',
  label05: '邮件通知',
  label06: '短信通知',
  label07: '设备名称',
  label08: '新入职',
  label09: '入职中',
  label10: '成功入职',
  label11: '人',
  label12: '加载更多',
  label13: '已加载全部',
  label14: '默认主题',
  label15: '红色主题',
  label16: '橙色主题',
  label17: '咖色主题',
  label18: '创建日期',
  label19: '截止日期',
  label20: '身份验证',
  label21: '完成',
  label22: '切换手机验证',
  label23: '手机验证码验证，为确认是本人操作，请完成以下验证：',
  label24: '手机号',
  label25: '切换邮箱验证',
  label26: '返回登录',
  label27: '账号',
  label28: '您已成功修改密码！',
  label29: '您已成功修改邮箱！',
  label30: '新邮箱',
  label31: '新手机',
  label32: '绑定手机',
  label33: '绑定',
  label34: '修改手机',
  label35: '您已成功绑定新手机',
  label36: '系统菜单',
  label37: '至',
  label38: '已设置',
  label39: '未设置',
  label40: '输入的邮箱错误，请输入正确的邮箱',
  label41: '发件人:',
  label42: '旋转',
  label43: '预览',
  label44: '关闭确认',
  label45: '接受用户协议是使用2175云平台的前提，否则将退出云平台！',
  label46: '申请人',
  label47: '输入的密码错误，请输入正确的密码',
  label48: '确认邮箱',
  label49: '午餐津贴',
  label50: '交通津贴',
  label51: '奖金',
  label52: '养老',
  label53: '失业',
  label54: '医疗',
  label55: '住房公积金',
  label56: '社保',
  label57: '个人所得税',
  label58: '小计',
  label59: '付款项',
  label60: '扣款项',
  label61: '实际收入',
  label62: '配额名称',
  label63: '小时',
  label64: '成功导入',
  label65: '失败',
  label66: '线上入职',
  label67: '线下入职',
  label68: '成功创建',
  label169: '图表',
  label170: '数据',
  label171: '级数',
  label172: '全月应缴纳所得税',
  label173: '税率',
  label174: '速算扣除数',
  label175: '账号（收款单位）',
  label176: '运营商认证',
  label177: '银行认证',
  label178: '人脸识别',
  label179: '企业信息',
  label180: '对公打款',
  label181: '完成',
  label182: '津贴',
  label183: '休息',
  label184: '日级别',
  label185: '班次名称',
  label186: '班次英文名',
  label187: '早退容忍时间(分钟)',
  label188: '迟到容忍时间(分钟)',
  label189: '工作时间(小时)',
  label190: '班次类型',
  label191: '工作计划',
  label192: '工作计划英文',
  label193: '排班',
  label194: '班次',
  label195: '假期名称',
  label196: '评估类型',
  label197: '考勤类型',
  label198: '地点',
  label199: '出差打卡',
  label120: '照片',
  label121: '范围(米)',
  label122: '出勤类型',
  label123: '班次类型英文',
  label124: '休息',
  label125: '休息英文',
  label126: '休息时间(小时)',
  label127: '付薪时间(小时)',
  label128: '假日英文名称',
  label129: '公共假日',
  label130: '评估类型英文',
  label131: '出勤类型英文',
  label132: '考勤类型英文',
  label133: '考勤评估单名称',
  label134: '工时上限',
  label135: '工时薪资',
  label136: '倍数',
  label137: '周期',
  label138: '是否扣减配额',
  label139: '最小单位(小时)',
  label140: '补偿方式',
  label141: '配额',
  label142: '舍弃规则',
  label143: '考勤类型名称',
  label144: '上班拍照',
  label145: '下班拍照',
  label146: '外出拍照',
  label147: '请假类型',
  label148: '补偿方式名称',
  label149: '请假类型英文',
  label150: '配额英文',
  label151: '补偿方式英文',
  label152: '日级别名称',
  label153: '日级别英文',
  label154: '地区',
  label155: '过程',
  label156: '公积金最低基数',
  label157: '公积金最高基数',
  label158: '公积金公司支付比例',
  label159: '公积金员工支付比例',
  label160: '工伤保险公司支付比例',
  label161: '工伤保险员工支付比例',
  label162: '生育保险公司支付比例',
  label163: '生育保险员工支付比例',
  label164: '医疗保险公司支付比例',
  label165: '医疗保险员工支付比例',
  label166: '养老保险公司支付比例',
  label167: '养老保险员工支付比例',
  label168: '社保最低基数',
  label200: '社保最高基数',
  label201: '补充公积金公司支付比例',
  label202: '补充公积金员工支付比例',
  label203: '补充医疗保险公司支付比例',
  label204: '补充医疗保险员工支付比例',
  label205: '补充养老保险公司支付比例',
  label206: '补充养老保险员工支付比例',
  label207: '失业保险公司支付比例',
  label208: '失业保险员工支付比例',
  label209: '缴费地区',
  label210: '缴税上限',
  label211: '缴税下限',
  label212: '缴税比例',
  label213: '扣除数',
  label214: '扣除方式',
  label215: '名称',
  label216: '简称',
  label217: '加减项',
  label218: '类型',
  label219: '当前周期',
  label220: '初始周期',
  label221: '追溯周期',
  label222: '时间周期',
  label223: '状态',
  label224: '公司',
  label225: '注意',
  label226: '是否加密',
  label227: '序列',
  label228: '注意英文',
  label229: '名称',
  label230: '字段',
  label231: '字段英文',
  label232: '解除绑定',
  label233: '个税',
  label234: '个税（企业支付）',
  label235: '个税退补',
  label236: '字段中文',
  label237: '过滤',
  label238: '过滤表名',
  label239: '不可修改',
  label240: '可修改',
  label241: '可编辑',
  label242: '图标',
  label243: '地址类型',
  label244: '地址类型英文',
  label245: '甲方签署',
  label246: '乙方签署',
  label247: '模板地址',
  label278: '经度',
  label279: '纬度',
  label280: '范围',
  label281: '组织架构',
  label282: '组织管理',
  label283: '汇报关系',
  label284: '配置',
  label285: '描述',
  label286: '图标',
  label287: '流程Id',
  label288: '同步Id',
  label289: '标题',
  label290: '时间',
  label291: '英文描述',
  label292: '只显示最近6个月的数据，历史数据请通过查找功能查询!',
  label293: '中文描述',
  label294: '支付比例',
  label295: '离职',
  label296: '模块',
  label297: '报表',
  label298: '自助中心审批流',
  label299: '算薪分组',
  label300: '报表数据',
  label301: '固定班次',
  label302: '动态班次',
  label303: '发展类型',
  label304: '中文名称',
  label305: '英文名称',
  label306: '任务描述',
  label307: '执行器',
  label308: 'job handler',
  label309: '执行范围',
  label310: '周期',
  label311: '任务参数',
  label312: '停止',
  label313: '运行中',
  label314: '重置密码链接将发送至该邮箱',
  label315: '文件列表',
  label316: '新增任务',
  table01: '姓名',
  table02: '工号',
  table03: '岗位',
  table04: '操作',
  table05: '部门',
  table06: '公司',
  table07: '开始日期',
  table08: '结束日期',
  table09: '员工类型',
  table10: '人事范围',
  table11: '员工组',
  table12: '异动类型',
  table13: '异动原因',
  table14: '算薪分组',
  table15: '备注',
  table16: '修改人',
  table17: '类型',
  table18: '城市',
  table19: '详细地址',
  table20: '电话',
  table21: '下属',
  table22: '成本中心',
  table23: '付款项',
  table24: '扣款项',
  table25: '金额',
  table26: '实际收入',
  table27: '百分比',
  table28: '员工状态',
  table29: '配额类型',
  table30: '组',
  table31: '队',
  table32: '主题',
  table33: '日期',
  table34: '状态',
  table35: '审批人',
  table36: '附件',
  table37: '付款方式',
  table38: '用途',
  table39: '岗位',
  table40: '员工',
  table41: '占比',
  table42: '姓名',
  table43: '工号',
  table44: '部门',
  table45: '公司',
  table46: '审核状态',
  table47: '审核意见',
  table48: '待批准',
  table49: '审批中',
  table50: '算薪分组',
  table51: '当前状态',
  table52: '算薪周期',
  table53: '算薪次数',
  table54: '回溯日期',
  table55: '员工列表',
  table56: '备注',
  table57: '月份',
  table58: '修改时间',
  table59: '上级菜单',
  table60: '角色',
  table61: '接受服务条款',
  table62: '开始菜单',
  table63: '修改原因',
  table64: '用户',
  table65: '岗位代码',
  table66: '角色ID',
  table67: '主管岗位',
  table68: '排除',
  table69: '查看者',
  table70: '信息类型',
  table71: '分类',
  table72: '薪资计算回溯',
  table73: '时间评估回溯',
  table74: '重复',
  table75: '员工可见',
  table76: '字段id',
  table77: '字段名称',
  table78: '产生机制',
  table79: '间隔',
  table80: '当前工号',
  table81: '长度',
  table82: '模板',
  table83: '期限',
  table84: '路径',
  table85: '法人',
  table86: '负责人',
  table87: '职能',
  table88: '职位描述',
  table89: '简称',
  table90: '全称',
  table91: '审批流',
  table92: '加密',
  table93: '首次周期',
  table94: '当前周期',
  table95: '头部',
  table96: '尾部',
  table97: '生效日期',
  table98: '失效日期',
  table99: '异常类型',
  table100: '异常内容',
  table101: '序号',
  table102: '总人数',
  table103: '总应付工资',
  table104: '总实付工资',
  table105: '申购人',
  table106: '地区',
  table107: '年份',
  table108: '月平均工资',
  table109: '年平均工资',
  table110: '班次日期',
  table111: '工作时间',
  table112: '迟到',
  table113: '早退',
  table114: '旷工',
  table115: '缺打卡',
  table116: '事假',
  table117: '病假',
  table118: '工作日加班',
  table119: '周末加班',
  table120: '国假加班',
  table121: '加班调休',
  table122: '加班异常',
  table123: '模板名称',
  table124: '所属企业',
  table125: '合同类型',
  table126: '创建时间',
  table127: '合同名称',
  table128: '公司',
  table129: '授权人',
  table130: '默认授权人',
  table131: '应出勤人数',
  table132: '实际出勤人数',
  table133: '应出勤小时数',
  table134: '实际出勤小时数',
  table135: '加班人数',
  table136: '加班时数',
  table137: '请假人数',
  table138: '请假时数',
  table139: '旷工人数',
  table140: '旷工时数',
  table141: '迟到人数',
  table142: '早退人数',
  table143: '迟到时数',
  table144: '早退时数',
  table145: '事假人数',
  table146: '事假时数',
  table147: '病假时数',
  table148: '班次津贴',
  table149: '病假人数',
  table150: '黑名单',
  table151: '合同数量',
  table152: '已签署合同',
  table153: '账号状态',
  table154: '租户编号',
  table155: '本人权限',
  table156: '排除人员',
  table157: '查看人员',
  table158: '年终奖实发基数',
  table159: '年假',
  table160: '调休假',
  table161: '婚假',
  table162: '产假',
  table163: '陪护假',
  table164: '丧假',
  table165: '工伤假',
  table166: '停薪留职',
  table167: '哺乳假',
  table168: '产检',
  table169: '其他（隔离）',
  table170: '平时',
  table171: '加班金额',
  table172: '周末',
  table173: '国假',
  table174: '出差打卡天数',
  table175: '补贴',
  table176: '餐费补贴',
  table177: '迟到（次）',
  table178: '早退（次）',
  table179: '缺卡（次）',
  table180: '次数',
  table181: '职业类型',
  table182: '类型规则',
  table183: '应付成本总额',
  table184: '其他扣',
  table185: '工资个税',
  table186: '公积金',
  table187: '社保',
  table188: '实发工资',
  table189: '应付工资人数',
  table190: '应付工资小计',
  table191: '社保人数',
  table192: '社保金额小计',
  table193: '公积金人数',
  table194: '公积金小计',
  table195: '入职汇总',
  table196: '离职汇总',
  table197: '职级代码',
  table198: '职级名称',
  table199: '是否主管',
  table200: '机构',
  table201: '月份',
  table202: '应付工资',
  table203: '班次时间',
  table204: '角色名称',
  table205: '班次时间',
  table206: '英文名',
  table207: '角色分配',
  table208: '验证基本信息',
  table209: '法人认证',
  table210: '创建签署账户',
  table211: '完成',
  table212: '验证打款账户',
  table213: '打款金额校验',
  table214: '验证短信验证码',
  table215: '加急处理',
  table216: '转签人',
  table217: '应出勤（H）',
  table218: '固定工资（元）',
  table219: '平时加班（H）',
  table220: '周末加班（H）',
  table221: '国假加班（H）',
  table222: '缺勤扣除（H）',
  table223: '全勤奖（元）',
  table224: '出差补贴（元）',
  table225: '奖惩（元）',
  table226: '2175云企业微信绑定',
  table227: '事假（H）',
  table228: '病假（H）',
  table229: '事假（H）',
  table230: '病假（H）',
  table231: '实际出勤（H）',
  table232: '餐费补助（元）',
  table233: '缺勤扣款（元）',
  table234: '应付工资（元）',
  table235: '社保（元）',
  table236: '公积金（元）',
  table237: '个税（元）',
  table238: '实发工资（元）',
  table239: '旷工（H）',
  table240: '加班工资（元）',
  table241: '入职文件',
  table242: '时间表',
  table243: '货币类型',
  table244: '规则类型',
  table245: '供应商类型',
  table246: 'No.',
  table247: '文件名',
  table248: '打开时间',
  table249: '关闭时间',
  table250: '工作内容',
  table288: '目录',
  table251: '出勤天数',
  table252: '加班出勤（平时）',
  table253: '加班出勤（周末）',
  table254: '加班出勤（国假）',
  table255: '加班换调休（H）',
  table256: '缺勤（H）',
  table257: '丧假（H）',
  table258: '带薪病假（H）',
  table259: '其他带薪假期（H）',
  table260: '平时出勤',
  table261: '年假（H）',
  table262: '班',
  table263: '休',
  table264: '应出勤',
  table265: '实际出勤',
  table266: '上班时间',
  table267: '下班时间',
  table268: '未审批',
  table269: '请假及外勤',
  table270: '员工确认',
  table271: '行号',
  table272: '其他假别',
  table273: '带薪病假',
  table274: '年假',
  form01: '工号',
  form02: '姓名',
  form03: '身份证',
  form04: '性别',
  form05: '生日',
  form06: '民族',
  form07: '籍贯',
  form08: '政治面貌',
  form09: '婚姻状况',
  form10: '用户名',
  form11: '邮箱',
  form12: '手机',
  form13: '招聘渠道',
  form14: '备注',
  form15: '最后修改人',
  form16: '银行',
  form17: '卡号',
  form18: '工作计划',
  form19: '评估类型',
  form20: '工卡代码',
  form21: '算薪分组',
  form22: '职级',
  form23: '金额',
  form24: '单位',
  form25: '关系',
  form26: '合同类型',
  form27: '学历类型',
  form28: '学校',
  form29: '专业',
  form30: '是否毕业',
  form31: '学位',
  form32: '最高学历',
  form33: '职称技能类型',
  form34: '等级',
  form35: '获得日期',
  form36: '数量',
  form37: '单位',
  form38: '借款物日期',
  form39: '归还日期',
  form40: '已还',
  form41: '需要时间',
  form42: '行业',
  form43: '发展项目',
  form44: '途径',
  form45: '伙伴姓名',
  form46: '伙伴类型',
  form47: '熟练程度',
  form48: '证书',
  form49: '时间评估日期',
  form50: '时间回溯日期',
  form51: '薪资计算日期',
  form52: '薪资回溯日期',
  form53: '是否锁定',
  form54: '锁定日期',
  form55: '工作计划',
  form56: '评估类型',
  form57: '工卡ID',
  form58: '地址类型',
  form59: '补偿方式',
  form61: '调班日期',
  form62: '调班事由',
  form63: '班次',
  form64: '假期类型',
  form65: '请假事由',
  form66: '配额',
  form67: '扣减开始日期',
  form68: '扣减结束日期',
  form69: '分配数量',
  form70: '扣减数量',
  form75: '加班事由',
  form76: '配额',
  form77: '时间',
  form78: '地点',
  form79: '类型',
  form80: '支付日期',
  form81: '薪资项',
  form82: '账户名',
  form83: '国籍',
  form84: '亲属姓名',
  form85: '紧急联系人',
  form86: '状态',
  form87: '调薪比例',
  form88: '调薪金额',
  form89: '套餐',
  form90: '描述',
  form91: '供应商',
  form92: '就餐时间',
  form93: '代码',
  form94: '车型',
  form95: '用车日期',
  form96: '还车日期',
  form97: '需求人数',
  form98: '岗位职责',
  form99: '岗位要求',
  form100: '希望到岗日期',
  form101: '入职方式',
  form102: '转正日期',
  form103: '试用期总结',
  form104: '目标岗位',
  form105: '调岗原因',
  form106: '调岗日期',
  form107: '离职原因',
  form108: '最后工作日',
  form109: '付款事由',
  form110: '支付对象',
  form111: '开户行',
  form112: '账户',
  form113: '用途',
  form114: '说明',
  form115: '用印日期',
  form116: '文件名称',
  form117: '文件类型',
  form118: '印章类型',
  form119: '规格',
  form120: '价格',
  form121: '合同编号',
  form122: '签约日期',
  form123: '签约单位',
  form124: '合同条款',
  form125: '项目名称',
  form126: '项目描述',
  form127: '项目目的',
  form128: '启动日期',
  form129: '人员需求',
  form130: '资金需求',
  form131: '验证结果',
  form132: '时长',
  form133: '更正方式',
  form134: '更正原因',
  form135: '日期时间',
  form136: '奖金类型',
  form137: '有效日期',
  form138: '工号',
  form139: '不存在',
  form140: '客户编号不存在',
  form141: '您的密码太短',
  form142: '至少包含小写字母、大写字母、数字和特殊字符4类字符中的3类，且长度不少于6位。',
  form143: '照片',
  form144: '退休',
  form145: '更正方式',
  form146: '请假时长',
  form147: '加班时长',
  form148: '补偿方式',
  form149: '更正时间',
  form150: '上车路线',
  form151: '上车点',
  form152: '下车点',
  form153: '需要时间',
  form154: '下车点是否相同',
  form155: '下车路线',
  form156: '密码限制条件：大写、小写、数字和特殊符号满足三个，且长度不小于6位',
  form157: '非本人邮箱',
  form158: '上传',
  form159: '来源',
  form160: '剩余数量',
  form161: '智能客服',
  form162: '算薪状态',
  form163: '员工工资',
  form164: '周期算薪',
  form165: '非周期算薪',
  form166: '当前状态',
  form167: '算薪次数',
  form168: '分配额',
  form169: '已使用',
  form170: '公司认证',
  form171: '员工认证',
  form172: '离职日期',
  form173: '小数位',
  form174: '规则',
  form175: '员工可编辑',
  form176: '审批',
  form177: '总价',
  form178: '信息',
  form179: '警告',
  form180: '错误',
  form181: '已处理',
  form182: '未处理',
  form183: '缴税类型',
  form184: '缴税地区',
  form185: '免除数',
  form186: '税阶',
  form187: '缴税方式',
  form188: '扣除方式',
  form189: '专项扣除',
  form190: '借款日期',
  form191: '借款人工号',
  form192: '借款人姓名',
  form193: '借款金额',
  form194: '付款单位',
  form195: '借款原因',
  form196: '申请原因',
  form197: '申请岗位',
  form198: '任职要求',
  form199: '预计到岗时间',
  form200: '五险类型',
  form201: '领款人工号',
  form202: '原借款',
  form203: '应退余款',
  form204: '是否占用部门费用额度',
  form205: '领款人姓名',
  form206: '合计',
  form207: '付款公司',
  form208: '经办人',
  form209: '付款用途',
  form210: '收款单位',
  form211: '关联客户',
  form212: '开户行（收款单位）',
  form213: '目标评分',
  form214: '行为评分',
  form215: '总体评分',
  form216: '出勤评估单',
  form217: '时间评估单',
  form218: '天数',
  form219: '出差事由',
  form220: '出发城市',
  form221: '目的城市',
  form222: '同行人',
  form223: '外出事由',
  form224: '原因',
  form225: '合同模板',
  form226: '供应商邮箱',
  form227: '供应商手机',
  form228: '年度绩效',
  form229: '半年度绩效',
  form230: '季度绩效',
  form231: '月度绩效',
  form232: '其它绩效',
  form233: '时长（天）',
  form234: '试用期KPI考核汇总',
  form235: '合同模板',
  form236: '个税退补',
  form237: '配额清单',
  form238: '员工姓名',
  form239: '员工工号',
  form240: '签署流程',
  form241: '住房公积金统筹（个人）',
  form242: '社会保险统筹（个人）',
  form243: '社会保险统筹（单位）',
  form244: '住房公积金统筹（单位）',
  form245: '线下应纳税所得额',
  form246: '本月出勤率',
  form247: '工序',
  form248: '数量下限',
  form249: '数量上限',
  form250: '计件单价',
  form251: '延期至',
  form252: '课程名称',
  form253: '培训方式',
  form254: '培训费用',
  form255: '培训地点',
  form256: '培训内容',
  form257: '培训理由',
  form258: '培训期望',
  form259: '考勤评估单',
  timeEvaluationTitleTemplate:
    '{year}年{month}月考勤评估单（考勤周期{startMonth}月{startDay}日至{endMonth}月{endDay}日）',
  form260: '出差地点',
  form261: '更新于',
  form262: '借款人',
  form263: '用途说明',
  form264: '还款方式',
  form265: '申请内容',
  form266: '具体详情',
  form267: '预算金额（元）',
  form268: '转出部门',
  form269: '转出日期',
  form270: '资产编号',
  form271: '资产名称',
  form272: '转移原因',
  form273: '接收部门',
  form274: '接收人',
  form275: '资产型号',
  form276: '请购部门',
  form277: '请购者',
  form278: '联系方式',
  form279: '请购品名规格',
  form280: '金额（元）',
  form281: '申请部门',
  form282: '申请日期',
  form283: '照会部门',
  form284: '签呈主旨',
  form285: '签呈内容',
  form286: '资产类别',
  form287: '截断原组织',
  form288: '移动日期',
  form289: '申请人（中文）',
  form290: '申请人（英文）',
  form291: '手机号码',
  form292: '电子邮件',
  form293: '申请名片盒数',
  form294: '事由',
  form295: '印章个数',
  form296: '项目编号',
  form297: '乘机人员',
  form298: '乘机部门',
  form299: '乘机身份证号码',
  form300: '联系方式',
  form301: '出行日期',
  form302: '始发地',
  form303: '目的地',
  form304: '办理人姓名',
  form305: '办理人部门',
  form306: '签证地',
  form307: '签证类型',
  form308: '出行时间',
  form309: '住宿日期',
  form310: '住宿原因',
  form311: '住宿标准',
  form312: '收件人',
  form313: '收件公司',
  form314: '收件公司地址',
  form315: '项目号',
  form316: '快递单号',
  form317: '采访事项备注',
  form318: '访客姓名',
  form319: '访客单位',
  form320: '访客类型',
  form321: '访客车牌',
  form322: '接待人',
  form323: '接待人电话',
  form324: '预计到访时间',
  form325: '报修内容',
  form326: '公里数',
  form327: '职务',
  form328: '出生日期',
  form329: '职等',
  form330: '技能',
  form331: '试用期薪资',
  form332: '周六加班补贴',
  form333: '绩效奖金',
  form334: '管理津贴',
  form335: '技能津贴',
  form336: '住宿补贴',
  form337: '电话补贴',
  form338: '全勤奖金',
  form339: '员工月薪',
  form340: '抄送人员',
  form341: '职位',
  form342: '线路',
  form343: '站点',
  form344: '使用人',
  form345: '份数',
  form346: '核准人',
  form347: '监章人',
  form348: '盖章内容',
  form349: '申请人职位',
  form350: '设备编号',
  form351: '型号',
  form352: '设备所在地',
  form353: '维修原因',
  form354: '申请部门意见',
  form355: '维修单位',
  form356: '维修或更换单位',
  form357: '申请人职务',
  form358: '用款理由',
  form359: '用款金额（元）',
  form360: '用款方式',
  form361: '收款人',
  form362: '银行账号',
  form363: '培训形式',
  form364: '培训机构',
  form365: '培训机类',
  form366: '申请理由',
  form367: '印章名称',
  form368: '保管部门',
  form369: '刻制人',
  form370: '印章专管员',
  form371: '印章用途',
  form372: '印章留样',
  form373: '型号/规格',
  form374: '单价',
  form375: '交货期',
  form376: '总数',
  form377: '申请人部门',
  form378: '附件张数',
  form379: '部门/职位',
  form380: '年假日数',
  form381: '假别代码',
  form382: '职务代理人',
  form383: '请购人',
  form384: '负责人签字',
  form385: '维修费',
  form386: '维修或更换零件部件',
  form387: '人事行政意见',
  form388: '经办人签字',
  form389: '预支旅费',
  form390: '金额大写',
  form391: '编号',
  form392: '注销的假期',
  form392_1: '注销的出差',
  form393: '注销原因',
  form394: '重新发起',
  form395: '用印时间',
  form396: '审批类型',
  form397: '直接员工',
  form398: '间接员工',
  form399: '病假天数',
  form400: '事假天数',
  form401: '夜班天数',
  form402: '年假天数',
  form403: '餐补',
  form404: '假日',
  form405: '总加班数',
  form406: '忘打卡次数',
  form407: '总工时',
  form408: '上班',
  form409: '下班',
  form410: '项目',
  form411: '任务',
  form412: '工时',
  form413: '工时合计',
  form414: '填报人',
  form415: '填报日期',
  form416: '工时',
  form417: '计划开始日期',
  form418: '计划结束日期',
  form419: '实际开始日期',
  form420: '实际结束日期',
  form421: '借款事由',
  form422: '请输入',
  form423: '借款方式',
  form424: '收款人名称',
  form425: '银行账户',
  form426: '付款金额',
  form427: '付款日期',
  form428: '关联申请单',
  form429: '摘要',
  form430: '发票总额',
  form431: '报销类型',
  form432: '报销事由',
  form433: '汽车',
  form434: '地点（从）',
  form435: '地点（至）',
  form436: '火车',
  form437: '飞机',
  form438: '住宿费',
  form439: '差旅补贴',
  form440: '共计报销金额',
  form441: '总金额',
  form442: '发票开具单位',
  form443: '冲账费用类型',
  form444: '申请事由',
  form445: '期望交付日期',
  form446: '物品名称',
  form447: '型号或规格',
  form448: '薪资',
  form449: '变动后部门',
  form450: '变动后岗位',
  form451: '变动后薪资',
  form452: '变动理由说明',
  form453: '员工本人意见',
  form454: '用印事由',
  form455: '文件份数',
  form456: '直属上级',
  form457: '毕业学校',
  form458: '录用薪资',
  form459: '拟报道日期',
  form460: '招聘岗位',
  form461: '招聘部门',
  form462: '需求类型',
  form463: '招聘人数',
  form464: '用车事由',
  form465: '车辆类型',
  form466: '用车时长',
  form467: '用车目的地',
  form468: '附试用期考核表',
  form469: '离职类型',
  form470: '差旅费',
  form471: '年龄',
  form472: '文化程度',
  form473: '毕业时间',
  form474: '职务等级',
  form475: '上次调薪时间',
  form476: '上次调薪金额',
  form477: '目前薪资',
  form478: '调整薪资',
  form479: '调薪幅度',
  form480: '调整生效日期',
  form481: '个人工作表现自评及工作目标调整',
  form482: '提交时间',
  form483: '当前审批状态',
  form484: '审批节点',
  form485: '操作记录',
  form486: '昶火微科',
  form487: '审批编号',
  form488: '打印日期',
  form489: '打印人',
  form490: '核销人',
  form491: '报销人',
  form492: '报销明细',
  form493: '项目日报',
  form494: '付款申请',
  form495: '差旅报销',
  form496: '费用报销',
  form497: '冲账核销',
  form498: '含税价',
  form499: '税率',
  form500: '金额合计',
  form501: '图片',
  form502: '暂存',
  form503: '获取暂存',
  form504: '是否已建采购单',
  form505: '建单',
  form506: '未建单',
  form507: '预约码',
  form508: '拜访事由',
  form509: '被访人',
  form510: '访客主导人',
  form511: '交通工具类型',
  form512: '车牌号',
  form513: '乘坐人数',
  form514: '单次通行距离',
  form515: '来访时间',
  form516: '访客邀约',
  form517: '发送预约码',
  form518: '待拜访',
  form519: '拜访中',
  form520: '签离',
  form521: '取消',
  form522: '汽油',
  form523: '电动',
  form524: '来访单位',
  form525: '来访者姓名',
  form526: '交通工具类型（汽油/电动）',
  form527: '公共交通',
  form528: '私家车',
  form529: '邀约码',
  form530: '报销公司',
  form531: '绩效奖金基数',
  form532: '调整',
  form533: '得分',
  form534: '最终绩效奖金',
  form535: '休假天数',
  form536: '伤害程度',
  form537: '伤害部位',
  form538: '医疗费用',
  form539: '地点',
  form540: '事情发生经过',
  form541: '根本原因分析',
  form542: '事故责任者',
  form543: '整改建议',
  form544: '整改措施及整改完成期限',
  form545: '事故整改跟踪报告',
  form546: '整改证据',
  form547: '安全事故记录表',
  form548: '薪资范围',
  form549: '离职审批单',
  recruitResignOrderLabel: '{name}的离职 {date}',
  form554: '需求岗位',
  form550: '培训类型',
  form551: '培训名称',
  form552: '培训目的',
  form558: '事件描述',
  form559: '原因分析',
  form560: '整改措施',
  form561: '完成时间',
  form562: '事件类型',
  form563: '发生地点',
  form564: '隐患描述',
  form565: '整改前照片',
  form566: '整改后照片',
  form567: '计划完成时间',
  form568: '整改完成时间',
  form569: '责任人',
  form570: '名片申请',
  form571: '英文名',
  form572: '岗位英文名',
  form573: '报修地点',
  form575: '办公电话',
  form576: '手机号',
  placeholder01: '搜索',
  placeholder02: '姓名',
  placeholder03: '密码',
  placeholder04: '验证码',
  placeholder05: '请输入正确的客户编号',
  placeholder06: '请输入正确的邮箱',
  placeholder07: '请输入正确的新密码',
  placeholder08: '请再次输入正确的新密码',
  placeholder09: '请输入正确的姓名',
  placeholder10: '请输入正确的电话',
  placeholder11: '请输入正确的邮箱',
  placeholder12: '请输入正确的内容',
  placeholder13: '请输入正确的原密码',
  placeholder14: '请输入正确的设备名称',
  placeholder15: '请选择正确的代理人',
  placeholder16: '请选择正确的开始时间',
  placeholder17: '请选择正确的结束时间',
  placeholder18: '请选择正确的工号',
  placeholder19: '请选择正确的部门',
  placeholder20: '请选择正确的公司',
  placeholder21: '请输入正确的工号',
  placeholder22: '请输入正确的身份证',
  placeholder23: '请选择正确的性别',
  placeholder24: '请选择正确的生日',
  placeholder25: '请输入正确的民族',
  placeholder26: '请输入正确的籍贯',
  placeholder27: '请输入正确的政治面貌',
  placeholder28: '请选择正确的婚姻状况',
  placeholder29: '请输入正确的用户名',
  placeholder30: '请输入正确的手机号码',
  placeholder31: '请选择正确的招聘渠道',
  placeholder32: '请输入正确的备注',
  placeholder33: '请选择正确的银行',
  placeholder34: '请输入正确的账号',
  placeholder35: '请选择正确的类型',
  placeholder36: '请选择正确的城市',
  placeholder37: '请输入正确的地址',
  placeholder38: '请选择正确的公司',
  placeholder39: '请输入正确的员工类型',
  placeholder40: '请选择正确的人事范围',
  placeholder41: '请选择正确的员工组',
  placeholder42: '请选择正确的岗位',
  placeholder43: '请选择正确的异动类型',
  placeholder44: '请选择正确的异动原因',
  placeholder45: '请选择正确的算薪分组',
  placeholder46: '请选择正确的时间',
  placeholder47: '请选择正确的城市',
  placeholder48: '请输入正确的百分比',
  placeholder49: '请选择正确的关系类型',
  placeholder50: '请选择正确的行业',
  placeholder51: '请选择正确的岗位',
  placeholder52: '请选择正确的发展项目',
  placeholder53: '请选择正确的发展途径',
  placeholder54: '请选择正确的伙伴类型',
  placeholder55: '请选择正确的伙伴',
  placeholder56: '请选择正确的伙伴名称',
  placeholder57: '请选择正确的调班日期',
  placeholder58: '请输入正确的调班事由',
  placeholder59: '请选择正确的班次',
  placeholder60: '请选择正确的假期类型',
  placeholder61: '请输入正确的请假事由',
  placeholder62: '请选择正确的配额类型',
  placeholder63: '请选择正确的扣减开始日期',
  placeholder64: '请选择正确的扣减结束日期',
  placeholder65: '请输入正确的分配数量',
  placeholder66: '请输入正确的扣减数量',
  placeholder67: '请输入正确的金额（元）',
  placeholder68: '请选择正确的单位',
  placeholder69: '请输入正确的数量',
  placeholder70: '请选择正确的开始日期',
  placeholder71: '请选择正确的结束日期',
  placeholder72: '请选择正确的员工状态',
  placeholder73: '请输入正确的工号',
  placeholder74: '请输入正确的账户名',
  placeholder75: '请选择正确的国籍',
  placeholder76: '请选择正确的学位',
  placeholder77: '请输入正确的学校',
  placeholder78: '请输入正确的专业',
  placeholder79: '请选择正确的等级',
  placeholder80: '请选择正确的获得日期',
  placeholder90: '请输入正确的工作计划',
  placeholder91: '请输入正确的评估类型',
  placeholder92: '请输入正确的名称',
  placeholder93: '请输入正确的组织',
  placeholder94: '请选择正确的职位',
  placeholder95: '请选择正确的职级',
  placeholder96: '请选择正确的工作地',
  placeholder97: '请选择正确的成本中心',
  placeholder98: '请选择正确的虚线汇报',
  placeholder99: '请选择正确的关键职位',
  placeholder100: '请选择正确的组织类别',
  placeholder101: '请选择正确的类别',
  placeholder102: '开始日期不能早于上级开始日期',
  placeholder103: '结束日期不能晚于上级的结束日期',
  placeholder104: '此节点已删除',
  placeholder105: '不能删除非空组织，请先删除其子组织和职位！',
  placeholder106: '不能直接新增新员工,您可以在员工档案下新增新员工',
  placeholder107: '该职位下已经有员工了，请选择其他职位',
  placeholder108: '你只可以选择一个职位为当前职位的虚线汇报职位,请重新选择',
  placeholder109: '请选择你要新增/修改的类型',
  placeholder110: '请输入正确的ID',
  placeholder111: '职位下不可新增职位或组织',
  placeholder112: '您只可以选择一个员工进行分配，请重新选择',
  placeholder113: '您只可以选择一个员工进行删除，请重新选择',
  placeholder114: '请选择入职日期',
  placeholder115: '请上传附件',
  placeholder116: '请选择正确的状态',
  placeholder117: '请调整比例',
  placeholder118: '请选择正确的套餐类型',
  placeholder119: '请选择正确的车型',
  placeholder120: '请选择正确的用车日期',
  placeholder121: '请选择正确的还车日期',
  placeholder122: '请输入正确的代码',
  placeholder123: '请选择正确的用餐时间',
  placeholder124: '请输入正确的领导岗位',
  placeholder125: '请输入正确的需求人数',
  placeholder126: '请输入正确的岗位职责',
  placeholder127: '请输入正确的岗位要求',
  placeholder128: '请选择正确的到岗日期',
  placeholder129: '请选择正确的入职方式',
  placeholder130: '请选择正确的转正日期',
  placeholder131: '请输入正确的试用期总结',
  placeholder132: '请选择正确的目标岗位',
  placeholder133: '请选择正确的调岗原因',
  placeholder134: '请选择正确的调岗日期',
  placeholder135: '请选择正确的离职原因',
  placeholder136: '请选择正确的最后工作日期',
  placeholder137: '请选择正确的付款方式',
  placeholder138: '请输入正确的目的',
  placeholder139: '请选择正确的日期',
  placeholder140: '请输入正确的付款事由',
  placeholder141: '请输入正确的支付对象',
  placeholder142: '请选择正确的支付日期',
  placeholder143: '请输入正确的开户行',
  placeholder144: '请输入正确的账户',
  placeholder145: '请输入正确的用途',
  placeholder146: '请输入正确的说明',
  placeholder147: '请选择正确的用印日期',
  placeholder148: '请输入正确的文件名称',
  placeholder149: '请选择正确的文件类型',
  placeholder150: '请选择正确的印章类型',
  placeholder151: '请输入正确的规格',
  placeholder152: '请输入正确的合同编号',
  placeholder153: '请选择正确的签约日期',
  placeholder154: '请输入正确的签约单位',
  placeholder155: '请输入正确的合同条款',
  placeholder156: '请选择正确的合同类型',
  placeholder157: '请输入正确的项目名称',
  placeholder158: '请输入正确的项目描述',
  placeholder159: '请输入正确的项目目的',
  placeholder160: '请输入正确的启动日期',
  placeholder161: '请输入正确的人员需求',
  placeholder162: '请输入正确的资金需求',
  placeholder163: '请选择正确的更正方式',
  placeholder164: '请选择正确的日期时间',
  placeholder165: '请输入正确的原因',
  placeholder166: '请选择正确的奖金类型',
  placeholder167: '请输入正确的问候语',
  placeholder168: '请输入正确的加班事由',
  placeholder169: '请选择正确的路线',
  placeholder170: '请选择正确的上车点',
  placeholder171: '请选择正确的下车点',
  placeholder172: '请输入正确的手机号码',
  placeholder173: '请输入验证码',
  placeholder174: '请输入正确的您的邮箱',
  placeholder175: '请输入正确的描述',
  placeholder176: '请输入',
  placeholder177: '请输入密码',
  placeholder178: '请选择正确的来源',
  placeholder179: '请选择正确的工号',
  placeholder180: '请输入正确的岗位',
  placeholder181: '请输入正确的数量',
  placeholder182: '请选择正确的关键岗位',
  placeholder183: '请输入需求人数',
  placeholder184: '请输入审核意见',
  placeholder185: '请输入您要发送的消息',
  placeholder186: '请输入正确的您的密码',
  placeholder187: '请输入正确的密码',
  placeholder188: '请选择正确的当前状态',
  placeholder189: '请选择正确的算薪周期',
  placeholder190: '请选择正确的算薪次数',
  placeholder191: '请选择正确的月份',
  placeholder192: '请选择正确的薪资项',
  placeholder193: '请选择正确的组织',
  placeholder194: '开始日期不能晚于结束日期',
  placeholder195: '结束日期不能早于开始日期',
  placeholder196: '请选择正确的补偿方式',
  placeholder197: '归还日期不能早于借款日期',
  placeholder198: '请输入正确的调薪比例',
  placeholder199: '截断日期不能早于开始日期',
  placeholder200: '请选择正确的认证时间',
  placeholder201: '请选择正确的认证方式',
  placeholder202: '请选择正确的员工认证方式',
  placeholder203: '请点击验证',
  placeholder204: '请输入正确的组织机构名称',
  placeholder205: '请输入正确的组织机构证件号',
  placeholder206: '请输入正确的法人姓名',
  placeholder207: '请输入正确的法人证件号',
  placeholder208: '请输入正确的对公账户开户行总行名称',
  placeholder209: '请输入正确的对公账户开户行所在省份名称',
  placeholder210: '请输入正确的对公账户开户行所在城市名称',
  placeholder211: '请输入正确的对公账户开户行支行名称全称',
  placeholder212: '请输入正确的收到的金额',
  placeholder213: '请选择正确的注册类型',
  placeholder214: '请选择正确的企业注册类型',
  placeholder215: '请选择正确的单位类型',
  placeholder216: '请选择正确的合同模板',
  placeholder217: '请选择正确的下车点',
  placeholder218: '请输入正确的代理人姓名',
  placeholder219: '请输入正确的ID',
  placeholder220: '请输入正确的名称',
  placeholder221: '请选择正确的语言',
  placeholder222: '请输入正确的ID或者名称',
  placeholder223: '请选择正确的HRBP',
  placeholder224: '结束日期不能早于上级开始日期',
  placeholder225: '请选择正确定时任务',
  placeholder226: '请选择正确周期',
  placeholder227: '请输入提前天数',
  placeholder228: '请输入正确的公司',
  placeholder229: '请输入正确的数量',
  placeholder230: '请选择正确的借款物日期',
  placeholder231: '请选择正确的熟练程度',
  placeholder232: '请选择正确的评估类型',
  placeholder233: '请选择正确的工作计划',
  placeholder234: '请选择正确的补偿方式',
  placeholder235: '请输入正确的单位',
  placeholder236: '请输入正确的价格',
  placeholder237: '请选择调班日期',
  placeholder238: '请输入正确的已还数量',
  placeholder239: '请输入时间（单位小时）',
  placeholder240: '还车日期不能早于用车日期',
  placeholder241: '请选择正确的上级菜单',
  placeholder242: '请选择正确的菜单',
  placeholder243: '扣减数量不得大于总数量',
  placeholder244: '请选择正确的离职日期',
  placeholder245: '请输入姓名',
  placeholder246: '请选择正确的国家',
  placeholder247: '请输入排序',
  placeholder248: '请选择正确的省',
  placeholder249: '请选择正确的规则',
  placeholder250: '请输入小数位',
  placeholder251: '请输入类型',
  placeholder252: '请输入电话',
  placeholder253: '请选择正确的通知方式',
  placeholder254: '请选择正确的修改原因',
  placeholder255: '请选择正确的角色',
  placeholder256: '请选择正确的开始菜单',
  placeholder257: '请输入调薪比例',
  placeholder258: '请输入正确的角色ID',
  placeholder259: '请输入路径',
  placeholder260: '请选择正确的模板',
  placeholder261: '请输入法人姓名',
  placeholder262: '请选择正确的岗位负责人',
  placeholder263: '请选择正确的职能',
  placeholder264: '请输入职位描述',
  placeholder265: '请输入简称',
  placeholder266: '请输入正确的全称',
  placeholder267: '请选择正确的审批流',
  placeholder268: '请选择正确的供应商',
  placeholder269: '请输入汇率',
  placeholder270: '请选择正确的货币',
  placeholder271: '请输入首次周期',
  placeholder272: '请输入当前周期',
  placeholder273: '请输入回溯日期',
  placeholder274: '请输入金额',
  placeholder275: '结束日期不能大于当前日期',
  placeholder276: '结束日期不能小于当前日期',
  placeholder277: '请输入工号头部',
  placeholder278: '请输入工号尾部',
  placeholder279: '请输入间隔',
  placeholder280: '请输入当前工号',
  placeholder281: '请输入长度',
  placeholder282: '请选择正确的产生机制',
  placeholder283: '请选择正确的用户',
  placeholder284: '截断日期不能晚于结束日期',
  placeholder285: '请输入手机号',
  placeholder286: '请输入邮箱',
  placeholder287: '请输入描述',
  placeholder288: '请选择正确的打卡地址',
  placeholder289: '请选择开始时间和结束时间！',
  placeholder290: '请输入8位及以下长度的正整数',
  placeholder291: '请输入正确的比例',
  placeholder292: '请选择缴税类型',
  placeholder293: '请选择缴税地区',
  placeholder294: '请选择缴税方式',
  placeholder295: '请选择扣除方式',
  placeholder296: '请选择正确的借款日期',
  placeholder297: '请填写正确的借款金额',
  placeholder298: '请选择正确的付款单位',
  placeholder299: '请填写借款原因',
  placeholder300: '请选择五险类型',
  placeholder301: '请选择正确的数据类型',
  placeholder302: '请输入免除数',
  placeholder303: '请选择正确的选项',
  placeholder304: '请输入小于100的值',
  placeholder305: '请选择正确的地区',
  placeholder306: '请选择正确的年份',
  placeholder307: '请输入正确的月平均工资！',
  placeholder308: '请选择正确的周期',
  placeholder309: '请输入正确的专项扣除',
  placeholder310: '请输入一个0—100的数字',
  placeholder311: '请选择缴费地区',
  placeholder312: '请选择支付方式',
  placeholder313: '请选择任务',
  placeholder314: '请输入正确的类别',
  placeholder315: '结束日期不能早于开始日期且必须选择相同年份',
  placeholder316: '请输入总体评分',
  placeholder317: '时长不能为0',
  placeholder318: '请选择岗位',
  placeholder319: '请输入出差事由',
  placeholder320: '请输入出发城市',
  placeholder321: '请输入目的城市',
  placeholder322: '请选择同行人',
  placeholder323: '请选择交通工具',
  placeholder324: '请输入外出事由',
  placeholder325: '同行人不能为本人',
  placeholder326: '请输入正确的模板名称',
  placeholder327: '请输入合同名称',
  placeholder328: '请选择所属公司',
  placeholder329: '请输入数字',
  placeholder330: '员工工作自评(客户意识，坚韧性，学习能力,沟通能力，内控能力，抗压能力)',
  placeholder331:
    '按照SWOT方式， 从工作总结，个人评价，说明性文字:“按照SWOT方式，从工作总结，个人评价，工作规划角度分析。(可上传附件)”',
  placeholder332: '1、学习需求(改进工作所必要的知识,职能和行为)',
  placeholder333: '2、行动计划(列如具体的培训课程和内容，指出哪些需得到公司的批准，并注明期限)',
  placeholder334: '3、工作发展期望(列出在未来-段时间内自己的工作计划与目标)',
  placeholder335: '请选择合同模板',
  placeholder336: '请选择授权人',
  placeholder337: '请选择默认授权人',
  placeholder338: '请选择算薪分组！',
  placeholder339: '请选择支付协议',
  placeholder340: '请填写正确的时间格式 （YYYY-MM-DD）',
  placeholder341: '开始日期不能晚于下级开始日期',
  placeholder342: '结束日期不能早于下级的结束日期',
  placeholder343: '请输入正确的养老保险',
  placeholder344: '请输入正确的医疗保险',
  placeholder345: '请输入正确的生育保险',
  placeholder346: '请输入正确的失业保险',
  placeholder347: '请输入正确的比例',
  placeholder348: '请选择正确的开始月份',
  placeholder349: '请选择正确的结束月份',
  placeholder350: '请选择正确的方式',
  placeholder351: '请输入名称',
  placeholder352: '请输入名称',
  placeholder353: '请选择正确的纬度',
  placeholder354: '请选择正确的年度',
  placeholder355: '截断日期不能等于结束日期',
  placeholder356: '调岗日期不能小于原岗位工作开始时间',
  placeholder357: '调岗日期不能大于原岗位工作结束时间',
  placeholder358: '请输入调薪比例',
  placeholder359: '请输入时长',
  placeholder360: '请选择正确的日期',
  placeholder361: '请选择正确的工序',
  placeholder362: '请输入数量下限',
  placeholder363: '请输入数量上限',
  placeholder364: '请输入计件单价',
  placeholder365: '数量上限不能小于数量下限',
  placeholder366: '请输入正确的计件单价（元）',
  placeholder367: '请选择正确的延期日期',
  placeholder368: '请输入途径',
  placeholder369: '请输入正确的课程名称',
  placeholder370: '请输入正确的培训方式',
  placeholder371: '请输入正确的培训费用',
  placeholder372: '请输入正确的培训地点',
  placeholder373: '请输入正确的培训内容',
  placeholder374: '请输入正确的培训理由',
  placeholder375: '请输入正确的培训期望',
  placeholder376: '延期日期不能早于扣减结束日期',
  placeholder377: '请输入8位及以下长度的整数',
  placeholder378: '请输入关键词',
  placeholder379: '请选择还款方式',
  placeholder380: '请输入申请内容',
  placeholder381: '请选择正确的部门',
  placeholder382: '请选择正确的转出日期',
  placeholder383: '请输入正确的资产编号',
  placeholder384: '请输入正确的资产名称',
  placeholder385: '请输入正确的转移原因',
  placeholder386: '请输入正确的资产型号',
  placeholder387: '请选择正确的资产类别',
  placeholder388: '请输入正确的联系方式',
  placeholder389: '请输入正确的请购品名规格',
  placeholder390: '请输入签呈主旨',
  placeholder391: '请输入签呈内容',
  placeholder392: '请输入照会部门',
  placeholder393: '请输入借款人',
  placeholder394: '请选择接收人',
  placeholder395: '请选择请购者',
  placeholder396: '请选择申请人',
  placeholder397: '请输入英文名',
  placeholder398: '请选择正确的截断日期',
  placeholder399: '请输入正确的数字',
  placeholder400: '已有重复数据',
  placeholder401: '移动日期不能小于开始日期',
  placeholder402: '截断日期不能大于结束日期',
  placeholder403: '请输入正确的补充养老',
  placeholder404: '请输入正确的补充医疗',
  placeholder405: '请输入正确的补充比例',
  placeholder406: '移动日期要大于等于上级开始时间',
  placeholder407: '组织结束时间要小于等于上级结束时间',
  placeholder408: '用车日期不能晚于还车日期',
  placeholder409: '请输入主题',
  placeholder410: '请输入班次名称',
  placeholder411: '请输入班次英文名称',
  placeholder412: '请输入津贴',
  placeholder413: '请输入早退容忍时间',
  placeholder414: '请输入迟到容忍时间',
  placeholder415: '请输入工作时间',
  placeholder416: '请选择休息',
  placeholder417: '请选择日级别',
  placeholder418: '请选择班次类型',
  placeholder419: '请输入工作计划',
  placeholder420: '请输入英文工作计划',
  placeholder421: '请选择排班',
  placeholder422: '请选择班次',
  placeholder423: '请输入假期名称',
  placeholder424: '请输入评估类型',
  placeholder425: '请选择考勤类型',
  placeholder426: '请输入打卡地点',
  placeholder427: '请选择是否需要打卡',
  placeholder428: '请输入照片',
  placeholder429: '请输入打卡范围',
  placeholder430: '请输入出勤类型',
  placeholder431: '请输入申请人（中文）',
  placeholder432: '请输入申请人（英文）',
  placeholder433: '请输入申请名片盒数',
  placeholder434: '请输入职位',
  placeholder435: '请输入电子邮件',
  placeholder436: '请输入事由',
  placeholder437: '请输入印章个数',
  placeholder438: '请输入申请人',
  placeholder439: '请输入项目编号',
  placeholder440: '请输入乘机人员',
  placeholder441: '请选择乘机部门',
  placeholder442: '请输入乘机身份证号码',
  placeholder443: '请输入联系方式',
  placeholder444: '请选择出行日期',
  placeholder445: '请输入始发地',
  placeholder446: '请输入目的地',
  placeholder447: '请输入办理人姓名',
  placeholder448: '请选择办理人部门',
  placeholder449: '请输入签证地',
  placeholder450: '请输入签证类型',
  placeholder451: '请选择出行时间',
  placeholder452: '请输入申请原因',
  placeholder453: '请选择住宿日期',
  placeholder454: '请输入住宿原因',
  placeholder455: '请输入住宿标准',
  placeholder456: '请输入人数',
  placeholder457: '请输入收件人',
  placeholder458: '请输入收件公司',
  placeholder459: '请输入收件公司地址',
  placeholder460: '请输入项目号',
  placeholder461: '请输入快递单号',
  placeholder462: '请输入访客姓名',
  placeholder463: '请输入访客单位',
  placeholder464: '请选择访客类型',
  placeholder465: '请输入访客车牌',
  placeholder466: '请输入接待人',
  placeholder467: '请输入接待人电话',
  placeholder468: '请选择预计到访时间',
  placeholder469: '请输入来访注意事项',
  placeholder470: '请输入报修内容',
  placeholder471: '请输入地点',
  placeholder472: '请输入班次类型',
  placeholder473: '请输入班次类型英文',
  placeholder474: '请输入休息名称',
  placeholder475: '请输入休息英文',
  placeholder476: '请输入休息时间',
  placeholder477: '请输入付薪时间',
  placeholder478: '请输入假日英文名称',
  placeholder479: '请选择公共假日',
  placeholder480: '请输入评估类型英文',
  placeholder481: '请输入出勤类型英文',
  placeholder482: '请输入公里数',
  placeholder483: '请选择正确的转签人',
  placeholder484: '请输入考勤类型英文',
  placeholder485: '请选择考勤评估单名称',
  placeholder486: '请输入工时上限',
  placeholder487: '请输入工时薪资',
  placeholder488: '请输入倍数',
  placeholder489: '请选择周期',
  placeholder490: '请选择是否扣减配额',
  placeholder491: '请输入最小单位且不能为负数',
  placeholder492: '请选择补偿方式',
  placeholder493: '请选择配额',
  placeholder494: '请输入舍弃规则',
  placeholder495: '请输入考勤类型名称',
  placeholder496: '请选择是否需要拍照',
  placeholder497: '请输入请假类型',
  placeholder498: '请输入配额名称',
  placeholder499: '请输入补偿方式名称',
  placeholder500: '请输入请假类型英文',
  placeholder501: '请输入配额英文',
  placeholder502: '请输入补偿方式英文',
  placeholder503: '请输入日级别名称',
  placeholder504: '请输入日级别英文',
  placeholder505: '请输入地区',
  placeholder506: '请输入公积金最低基数',
  placeholder507: '请输入公积金最高基数',
  placeholder508: '请输入公积金公司支付比例',
  placeholder509: '请输入公积金员工支付比例',
  placeholder510: '请输入工伤保险公司支付比例',
  placeholder511: '请输入工伤保险员工支付比例',
  placeholder512: '请输入生育保险公司支付比例',
  placeholder513: '请输入生育保险员工支付比例',
  placeholder514: '请输入医疗保险公司支付比例',
  placeholder515: '请输入医疗保险员工支付比例',
  placeholder516: '请输入养老保险公司支付比例',
  placeholder517: '请输入养老保险员工支付比例',
  placeholder518: '请输入社保最低基数',
  placeholder519: '请输入社保最高基数',
  placeholder520: '请输入补充公积金公司支付比例',
  placeholder521: '请输入补充公积金员工支付比例',
  placeholder522: '请输入补充医疗保险公司支付比例',
  placeholder523: '请输入补充医疗保险员工支付比例',
  placeholder524: '请输入补充养老保险公司支付比例',
  placeholder525: '请输入补充养老保险员工支付比例',
  placeholder526: '请输入失业保险公司支付比例',
  placeholder527: '请输入失业保险员工支付比例',
  placeholder528: '请输入缴费地区',
  placeholder529: '请输入缴税上限',
  placeholder530: '请输入缴税下限',
  placeholder531: '请输入缴税比例',
  placeholder532: '请输入扣除数',
  placeholder534: '请选择扣除方式',
  placeholder535: '请输入名称',
  placeholder536: '请输入简称',
  placeholder537: '请选择加减项',
  placeholder538: '请选择类型',
  placeholder539: '请选择当前周期',
  placeholder540: '请选择初始周期',
  placeholder541: '请选择追溯周期',
  placeholder542: '请选择时间周期',
  placeholder543: '请输入状态',
  placeholder544: '请选择公司',
  placeholder545: '请输入注意',
  placeholder546: '请选择是否加密',
  placeholder547: '请输入职务',
  placeholder548: '请输入学历',
  placeholder549: '请输入序列',
  placeholder550: '请输入职等',
  placeholder551: '请输入基本工资',
  placeholder552: '请输入技能',
  placeholder553: '请输入试用期薪资',
  placeholder554: '请输入周六加班补贴',
  placeholder555: '请输入绩效奖金',
  placeholder556: '请输入管理津贴',
  placeholder557: '请输入技能津贴',
  placeholder558: '请输入住宿补贴',
  placeholder559: '请输入电话补贴',
  placeholder560: '请输入全勤奖金',
  placeholder561: '请输入员工月薪',
  placeholder562: '请选择出生日期',
  placeholder563: '请输入注意英文',
  placeholder564: '不能早于开始时间',
  placeholder565: '不能晚于结束时间',
  placeholder566: '请选择正确的账号状态',
  placeholder567: '请填写打卡地址',
  placeholder568: '打卡地址不能为空',
  placeholder569: '请填写打卡地址',
  placeholder570: '请输入名称',
  placeholder571: '请输入字段名称',
  placeholder572: '请输入字段英文',
  placeholder573: '请输入字段值',
  placeholder574: '请输入合同数量',
  placeholder575: '请输入图标',
  placeholder576: '请输入地址类型',
  placeholder577: '请输入地址类型英文',
  placeholder578: '请输入合同类型',
  placeholder579: '请输入过滤表名',
  placeholder580: '请输入模板地址',
  placeholder581: '请选择合同类型',
  placeholder582: '请输入经度',
  placeholder583: '请输入维度',
  placeholder584: '请输入范围',
  placeholder585: '请输入配置',
  placeholder586: '请选择菜单',
  placeholder587: '请输入描述',
  placeholder588: '请输入图标',
  placeholder589: '请输入流程Id',
  placeholder590: '请输入同步Id',
  placeholder591: '请输入标题',
  placeholder592: '请选择供应商',
  placeholder593: '请选择时间',
  placeholder594: '请输入描述英文',
  placeholder595: '请输选择名称',
  placeholder596: '请输入英文字符',
  placeholder597: '请输入正整数',
  placeholder598: '请输入正整数并且最大位数为8位',
  placeholder599: '请输入支付比例',
  placeholder600: '请输入整数最多6位,小数最多2位的数字',
  placeholder601: '请输入整数最多5位,小数最多2位的数字',
  placeholder602: '请输入整数最多2位,小数最多1位的数字',
  placeholder603: '请输入整数最多5位,小数最多3位的数字',
  placeholder604: '开始时间不能晚于结束时间',
  placeholder605: '结束时间不能早于开始时间',
  placeholder606: '请输入自然数',
  placeholder607: '请输入整数最多17位,小数最多3位的数字',
  placeholder608: '请输入赔偿倍率',
  placeholder609: '请输入n+',
  placeholder610: '请选择模块',
  placeholder611: '休息时间+付薪时间不等于结束时间-开始时间',
  placeholder612: '新工号必须大于等于之前的工号',
  placeholder613: '请选择班次类型',
  placeholder614: '请选择发展类型',
  placeholder615: '请选择员工',
  placeholder616: '请输入手机号码',
  placeholder617: '请选择职等',
  placeholder618: '请选择异动类型',
  placeholder619: '头部长度+尾部长度+长度小于等于20',
  placeholder620: '新邮箱输入框不能为空！',
  placeholder621: '验证码输入框不能为空！',
  placeholder622: '请输入过程',
  placeholder623: '请输入任务描述',
  placeholder624: '请选择执行器',
  placeholder625: '请输入job handler',
  placeholder626: '请选择执行范围',
  placeholder627: '请选择周期',
  placeholder628: '请选择任务参数',
  placeholder629: '请选择线路',
  placeholder630: '请选择站点',
  placeholder631: '请填写使用人',
  placeholder632: '请填写份数',
  placeholder633: '请填写核准人',
  placeholder634: '请填写监章人',
  placeholder635: '请填写盖章内容',
  placeholder636: '请填写申请人职位',
  placeholder637: '请填写设备编号',
  placeholder638: '请填写型号',
  placeholder639: '请填写设备所在地',
  placeholder640: '请填写维修原因',
  placeholder641: '请填写申请部门意见',
  placeholder642: '请填写维修单位',
  placeholder643: '请填写维修或更换单位',
  placeholder644: '请填写申请人职务',
  placeholder645: '请填写用款理由',
  placeholder646: '请填写用款金额（元）',
  placeholder647: '请填写用款方式',
  placeholder648: '请填写收款人',
  placeholder649: '请填写银行账号',
  placeholder650: '请选择培训形式',
  placeholder651: '请填写培训机构',
  placeholder652: '请填写培训机类',
  placeholder653: '请填写申请理由',
  placeholder654: '请填写印章名称',
  placeholder655: '请填写保管部门',
  placeholder656: '请填写刻制人',
  placeholder657: '请填写印章专管员',
  placeholder658: '请填写印章用途',
  placeholder659: '请填写印章留样',
  placeholder660: '请填写型号/规格',
  placeholder661: '请选择交货期',
  placeholder662: '请输入正确的单价',
  placeholder663: '请输入单位',
  placeholder664: '请选择日期',
  placeholder665: '请填写附件张数',
  placeholder666: '请选择年假代码',
  placeholder667: '请选择职务代理人',
  placeholder668: '请选择学历',
  placeholder669: '请填写维修费',
  placeholder670: '请填写人事行政意见',
  placeholder671: '请填写预支旅费',
  placeholder672: '请选择需要注销的假期',
  placeholder673: '请填写注销原因',
  placeholder674: '编辑服务条款内容',
  placeholder675: '请选择上级组织',
  placeholder676: '请选择项目',
  placeholder677: '请选择任务',
  placeholder678: '请填写工时',
  placeholder679: '请选择实际结束日期',
  placeholder680: '请选择负责人',
  placeholder681: '请选择填报人',
  placeholder682: '请选择填报日期',
  placeholder683: '请输入工时',
  placeholder684: '请填写编号',
  placeholder685: '请选择计划开始日期',
  placeholder686: '请选择计划结束日期',
  placeholder687: '请选择实际开始日期',
  placeholder688: '冲账事由说明',
  placeholder689: '自动计算结果',
  placeholder690: '请填写',
  placeholder691: '请按照差旅补贴标准填写',
  placeholder692: '借款日期不能晚于归还日期',
  placeholder693: '请输入正确的工时',
  placeholder694: '请填写工作内容',
  placeholder695: '请输入毕业学校',
  placeholder696: '请输入录用薪资',
  placeholder697: '请输入试用期',
  placeholder698: '请上传附试用期考核表',
  placeholder699: '请输入离职原因',
  placeholder700: '请选择离职类型',
  placeholder701: '离职时间不能早于入职时间',
  placeholder702: '转正时间不能早于入职时间',
  placeholder703: '请输入正确的年龄',
  placeholder704: '请输入编号',
  placeholder705: '请输入审批意见',
  placeholder706: '系统自动生成',
  placeholder707: '请输入正确的含税价',
  placeholder708: '请输入正确的税率',
  placeholder709: '请输入拜访事由',
  placeholder710: '请输入被访人',
  placeholder711: '请输入访客主导人',
  placeholder712: '请选择交通工具类型',
  placeholder713: '请输入车牌号',
  placeholder714: '请输入正确的乘坐人数',
  placeholder715: '请输入正确的单次通行距离',
  placeholder716: '请输入来访时间',
  placeholder717: '请选择交通工具',
  placeholder718: '访客邀约链接过期',
  placeholder719: '访客邀约链接无效',
  placeholder720: '请输入绩效奖金基数',
  placeholder721: '请输入得分',
  placeholder722: '请输入最终绩效奖金',
  placeholder723: '请输入',
  placeholder724: '请输入休假天数',
  placeholder725: '请输入薪资范围',
  placeholder726: '请选择离职审批单',
  placeholder727: '请选择培训类型',
  placeholder728: '请输入培训名称',
  placeholder729: '请输入培训目的',
  placeholder730: '请输入事件描述',
  placeholder731: '请输入原因分析',
  placeholder732: '请输入整改措施',
  placeholder733: '请选择完成时间',
  placeholder734: '请选择事件类型',
  placeholder735: '请输入隐患描述',
  placeholder736: '请上传整改前照片',
  placeholder737: '请上传整改后照片',
  placeholder738: '请选择计划完成时间',
  placeholder739: '请选择整改完成时间',
  placeholder740: '请选择责任人',
  placeholder741: '请输入英文名',
  placeholder742: '请输入岗位英文名',
  placeholder743: '请输入报修地点',
  placeholder744: '请输入正确的邮箱格式',
  placeholder745: '请选择员工类型',
  placeholder746: '请选择异动类型',
  placeholder747: '请选择计划生效日期',
  placeholder748: '请输入办公电话',
  placeholder749: '请输入手机号',
  contentTitle01: '一、服务条款的确认和接纳',
  contentTitle02: '二、服务保护条款',
  contentTitle03: '三、服务内容',
  contentTitle04: '四、用户使用规则',
  contentTitle05: '五、服务条款的修改与公示',
  contentTitle06: '六、服务修订',
  contentTitle07: '七、用户的权利及义务',
  contentTitle08: '八、违约条款',
  contentTitle09: '九、结束服务',
  contentTitle10: '十、知识产权',
  contentTitle11: '十一、争议解决',
  contentTitle12: '十二、其他',
  content01:
    '2175云是由苏州路卡信息科技有限公司开发的一款专业的人力资源SAAS云平台。用户登录并使用本服务前，应认真阅读《2175云服务条款》（以下简称“本协议”）。请务必审慎阅读、充分理解各条款内容，特别是免除或者限制责任等条款。用户在首次登录云平台过程中勾选“我已仔细阅读并同意用户协议”并点击“确定”按钮，即表示用户与苏州路卡信息科技有限公司已达成协议，自愿接受本服务条款的所有内容。任何修订和新规则一经公布即自动成为本服务条款的一部分，用户登录或继续使用服务的行为将被视为接受上述规则修改并愿意继续履行合同的意思表示。苏州路卡信息科技有限公司享有旗下2175云应用上一切活动的监督、提示、检查、纠正及处罚等权利。',
  content02:
    '1、2175云是由苏州路卡信息科技有限公司用自己的云服务系统通过国际互联网络为用户提供各项人力资源管理在线云服务，用户必须：•(1) 自备设备，包括但不限于个人电脑及配备上网装置;•(2) 用户上网并自行支付与此服务有关的费用。',
  content03:
    '1、围绕企业管理的各种服务2175云为用户提供各种与企业管理与经营相关的服务。用户通过在线自助将需要的信息上传到2175云服务器，2175云通过对客户上传的信息提供专业的人力资源服务。2、2175云2175云为用户提供HR业务集成的云服务平台，用户通过人员HR云服务平台对人力资源管理云应用进行集成和部署。3、其他伙伴提供的相关增值服务2175云会根据用户的各种需求，推荐合作伙伴提供各种包括但不限于咨询、培训、业务外包、信息分析等服务，通过系统协助完成在线交易。',
  content04: '警告',
  content05:
    '特别提示用户，使用2175云提供的网络服务必须遵守国家有关的政策和法律，包括刑法、国家安全法、保密法及其他计算机信息系统安全保护条例等，用户应自觉维护国家利益，保护国家安全，对于违法使用2175云提供的网络服务而引起的一切责任，由用户自行承担全部责任。1、用户在申请使用2175云提供的网络服务时，必须向2175云提供真实准确的个人资料或机构资料，如个人资料或机构资料有任何变动，必须及时更新。2、用户登录成功后，2175云将给予每个用户一个/多个用户账号及相应的密码，该用户账号和密码由用户负责保管；用户可随时改变自己的密码。用户应当对以其用户账号进行的所有活动和事件承担法律责任，用户若发现任何非法使用本人用户账号或安全漏洞的情况，立即通告2175云。3、用户不得使用2175云服务发送或传播违反国家法律制度的信息、敏感信息和不宜发送或传播的信息，包括但不限于下列信息：•(1) 反对宪法所确定的基本原则的；•(2) 危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；•(3) 损害国家荣誉和利益的；•(4) 煽动民族仇恨、民族歧视，破坏民族团结的；•(5) 破坏国家宗教政策，宣扬邪教和封建迷信的；•(6) 散布谣言，扰乱社会秩序，破坏社会稳定的；•(7) 散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；•(8) 侮辱或者诽谤他人，侵害他人合法权益的；•(9) 含有法律、行政法规禁止的其他内容的。4、用户在使用2175云网络服务过程中，必须遵循以下原则：•(1) 遵守中国有关的法律和法规；•(2) 不得为任何非法目的而使用网络服务系统；•(3) 遵守所有与网络服务有关的网络协议、规定和程序；•(4) 不得利用2175云进行任何可能对互联网的正常运转造成不利影响的行为；•(5) 不得利用2175云传输任何骚扰性的、中伤他人的、辱骂性的、恐吓性的、庸俗淫秽的或其他任何非法的信息资料；•(6) 不得利用2175云进行任何不利于2175云的行为。若用户的行为不符合以上提到的服务条款，2175云将作出独立判断立即取消用户服务账号。5、使用2175云网站服务，用户应加强个人或机构资料的保护意识，并注意用户账号的密码保护。6、盗取他人用户账号或利用网络通讯骚扰他人，均属于非法行为。用户不得采用测试、欺骗等任何非法手段，盗取其他用户的账号和对他人进行骚扰。7、苏州路卡信息科技有限公司保留独立判定用户的行为是否符合2175云服务条款的要求和精神的权利，如果用户违背了服务条款的规定，苏州路卡信息科技有限公司有权自行中断或删除其账号。如用户对2175云中断或删除行为有异议的，应自中断或删除行为作出后五个工作日内向苏州路卡信息科技有限公司书面提出。8、2175云不对用户所发布信息的自行删除或储存失败承担责任。9、所有发给用户的通告都可通过电子邮件或常规的信件传送。2175云会通过邮件服务发报消息给用户，告知服务条款的修改、服务变更、或其它重要事项。',
  content06:
    '苏州路卡信息科技有限公司会在必要时修改服务条款，一旦本协议的内容发生变动，苏州路卡信息科技有限公司将会直接在网站上公布修改之后的协议内容，该公布行为视为苏州路卡信息科技有限公司已经通知用户修改内容。 苏州路卡信息科技有限公司也可通过其他适当方式向用户提示修改内容。如果不同意苏州路卡信息科技有限公司对本协议相关条款所做的修改，用户有权停止使用网络服务，如果用户继续使用网络服务，则视为用户接受苏州路卡信息科技有限公司对本协议相关条款所做的修改。 若有任何服务条款与法律相抵触，那这些条款将按尽可能接近的方法重新解析，而其它条款则继续对用户产生法律效力和影响。',
  content07:
    '2175云特别提示用户，2175云为了保障系统升级，有权修改或中断服务，2175云通过网站公告或者邮件方式通知用户修改或者中断服务的时间段，在中断服务期间，用户将无法网上操作，请用户注意查看公告或查收邮件信息。',
  content08:
    '•(1) 用户应向2175云提供其用过的人事信息，包括但不限于工商营业执照、现有人员配置信息及其他资料。•(2) 用户应积极配合2175云提供相应资料，用户可根据自身的需要和特点，选择适合的方案，例如可以选择适用2175云提供的在线云服务。•(3) 在合作期内，用户保证其提供给2175云的内容(包括嵌套的信息内容)等资料真实、合法，且不侵犯第三方的合法权益。用户应对该内容享有相应的知识产权或合法使用权，该等权利证明文件应同时提交2175云。•(4)用户对2175云负有保密义务，不得以任何方式向其他第三方披露透露在履行本协议过程中知悉的2175云任何信息。•(5) 用户应在本协议约定的范围内使用2175云的名称及标识。如确需在2175云之外使用2175云名称和标识的，应取得苏州路卡信息科技有限公司的书面授权。用户应保证妥善使用2175云的名称和标识，不得随意修改、剪裁、变更或不恰当引用。•(6) 经苏州路卡信息科技有限公司书面许可，用户可在其发布的信息中加入宣传资料或广告策划，在2175云提供的各项免费服务中展示其产品。用户应保证其发布内容的真实性与合法性。2175云对上述内容不作实质性审查，用户与第三方因此发生纠纷的，应自行承担全部责任，由此给苏州路卡信息科技有限公司造成损失的，用户应予赔偿。',
  content09:
    '•(1) 本协议的订立、执行和解释及争议的解决均应适用中华人民共和国法律。•(2) 本协议自您登录使用2175云起生效，长期有效•(3) 苏州路卡信息科技有限公司保留在法律允许范围内对本协议的最终解释权。',
  content10:
    '用户若反对任何服务条款的建议或对后来的条款修改有异议，或对苏州路卡信息科技有限公司服务不满，用户享有以下的权利：•(1) 不再使用2175云的服务•(2) 结束用户使用2175云服务的资格。•(3) 书面通告苏州路卡信息科技有限公司停止该用户的服务。结束用户服务后，用户使用2175云服务的权利马上终止，且苏州路卡信息科技有限公司不再对用户承担任何义务。',
  content11:
    '用户保证和声明对其所提供的作品拥有完整的合法的著作权或完整的合法的授权可以用于其在2175云上从事的活动，保证2175云使用该作品不违反国家的法律法规，也不侵犯第三方的合法权益或承担任何义务。用户应对其所提供作品因形式、内容及授权的不完善、不合法所造成的一切后果承担完全责任。苏州路卡信息科技有限公司保留对2175云网站所有内容进行实时监控的权利，并有权依其独立判断对任何违反本协议约定的作品实施删除，2175云对于删除用户作品引起的任何后果或导致用户的任何损失不负任何责任。因用户作品的违法或侵害第三人的合法权益而导致2175云公司或其关联公司对第三方承担任何性质的赔偿、补偿或罚款而遭受损失(直接的、间接的、偶然的、惩罚性的和继发的损失)，用户对于苏州路卡信息科技有限公司及其关联公司或2175云蒙受的上述损失承担全面的赔偿责任。',
  content12:
    '如双方就本协议内容或其执行发生任何争议，双方应尽量友好协商解决。协商不成时，任何一方均可向苏州路卡信息科技有限公司所在地的法院提起诉讼。',
  content13:
    '•(1) 2175云将视向用户所提供服务内容之特性，要求用户在注册2175云提供的有关服务时，遵守特定的条件和条款；如该特定条件和条款与以上服务条款有任何不一致之处，则以特定条件和条款为准。•(2)本服务条款中的某一条款无论因何种原因被认定为无效或不具有执行力，不影响其余条款仍应有效并且有约束力。•(3) 本服务条款执行过程中所产生的任何问题，2175云和用户都将友好协商解决。•(4) 以上条款的解释权归苏州路卡信息科技有限公司最终所有。2175云用户资料保密承诺2175云（https://cloud.luttica.com/）是由苏州路卡信息科技有限公司，以下简称苏州路卡信息科技有限公司或路卡信息科技）开发的一款在线人力资源管理工具。为更好的满足用户的需求，服务于用户，针对用户资料信息安全，苏州路卡信息科技有限公司公司做出如下保密承诺。1、承诺保密范围2175云注册使用的所涉及到得所有客户输入到系统中的员工档案资料、客户信息。包括：员工档案、员工数据等属于客户保密的资料。2、保密责任未经用户许可，苏州路卡信息科技有限公司应做到以下保密责任：•a. 苏州路卡信息科技有限公司必须采取有效的安全措施和操作规程防止用户信息被泄露。•b. 苏州路卡信息科技有限公司不可将用户信息泄露给第三方，只允许将信息透露给用户的管理级人员、签约者。•c. 苏州路卡信息科技有限公司采取有效措施对所有来自用户信息永久严格保密。3、使用限制承诺•a.未经用户同意，苏州路卡信息科技有限公司不得透露涉及商业使用权、专利权、复制权、商标、技术机密、商业机密或其他归用户专有的权利。•b. 未经用户同意，苏州路卡信息科技有限公司不得擅自将合作的事宜和保密内容，用作商业宣传或者为商业目的而透露给用户的商业竞争伙伴或其他威胁到用户利益的单位或个人。4、其他保密承诺自客户注册使用苏州路卡信息科技有限公司的2175云时生效，生效前提为不违反中华人民共和国的法律法规，不危害社会安全，不损害国家利益。在下列情形下，苏州路卡信息科技有限公司公司不承担保密责任。•1、 在用户使用或者公布前，信息已经被他人知晓或已公开，或者非苏州路卡信息科技有限公司的错误行为导致的信息已公开。•2、用户没有对苏州路卡信息科技有限公司发布限制要求的情况下公布的信息。•3、原则上服务结束后，苏州路卡信息科技有限公司也将对所有来自用户的信息永久严格保密。',
  content14: '适用于新员工录入申请，审批通过自动进入待入职状态，审批通过自动进入待入职状态',
  content15: '该截断会同时截断它下级的组织、岗位及分配员工的结束日期，请确认是否继续截断？',
  content16: '您确定要暂停当前申请吗？',
  content17: '您确定要取消当前申请吗？',
  rules01: '请填写正确的用户名',
  rules02: '请填写正确的密码',
  rules03: '请完成验证！',
  rules04: '请填写正确的客户编号',
  rules05: '请填写正确的邮箱',
  rules06: '两次密码不一致',
  rules07: '请输入正确的姓名',
  rules08: '请输入正确的电话',
  rules09: '请输入正确的内容',
  rules10: '请输入正确的设备名称',
  rules11: ' 用户名',
  rules12: ' 电话',
  rules13: ' 邮箱',
  rules14: '请输入正确的',
  rules15: '请选择正确的关系',
  rules16: '请填写正确的密码',
  rules17: '请填写正确的邮箱',
  rules18: '用户名不能为空',
  rules19: '密码不能为空',
  rules20: '您还未绑定手机号！',
  rules21: '您还未绑定邮箱',
  rules22: '您的手机号',
  rules23: '请输入规定特殊字符[  ,/,:,@,[,`,{,~ ]',
  rules24: '请选择正确的日期',
  rules25: '不能为空',
  rules26: '已存在相同合同',
  message01: '注销失败，请重试！',
  message02: '重置成功，请重新登录！',
  message03: '登录成功！',
  message04: '注销成功！',
  message05: '数据输入有误，请核实！',
  message06: '提交成功！',
  message07: '编辑我的应用',
  message08: '编辑完成！',
  message09: '修改成功！',
  message10: '绑定成功！',
  message11: '解绑成功！',
  message12: '图片类型必须是.gif,jpeg,jpg,png,bmp中的一种',
  message13: '上传背景图片大小不能超过 2MB！',
  message14: '添加背景成功！',
  message15: '删除成功！',
  message16: '复制成功！',
  message17: '保存成功！',
  message18: '请选择最少一条消息！',
  message19: '退出编辑',
  message20: '验证通过',
  message21: '新密码不能与旧密码相同！',
  message22: '取消输入正确',
  message23: '加班具体时间段',
  message24: '对不起，系统遇到错误！您可以尝试刷新或者返回首页。',
  message25: '重置成功，请重新登录！',
  message26: '取消删除！',
  message27: '该员工未注册账号！',
  message28: '您不能修改自己的数据！',
  message29: '如无关联客户，可填客户无！',
  message30: '发票合同等凭证',
  message31: '交接内容说明：',
  message32: '工作事项：1.应收账款 2.报销事项 3.候选人信息及list 4.其他',
  message33: '人力资源部交接：邮箱、品聘、钉钉、Teams、电脑密码、电脑资料备档、名片、微信、钥匙',
  message34: '实际申请人负责的审批单将在离职后转给交接人负责',
  message35: '至少填写一个筛选条件',
  message36: '你选择的支付方式，审批完成后需要手动完成支付！',
  message37: '同行人错误,不能选择自己为同行人',
  message38: '保存成功，您可以通过新增来添加更多记录，或者点击右边箭头前往下一个信息类型！',
  message39: '请先点击下面保存按保存当前数据哦～',
  message40: '与已有数据重叠，是否覆盖原有记录？',
  message41: '转签成功',
  message42: '链接错误',
  message43: '没有找到绑定的用户!',
  message44: '绑定失败！',
  message45: '解除绑定成功！',
  message46: '解除绑定失败！',
  message47: '您还未绑定手机号和邮箱，请先绑定手机号和邮箱',
  message48: '系统更新中。。。。',
  message49: '说明：如设备损坏是人为原因造成，维修费用由使用人自理或照价赔偿。',
  message50: '用户没有岗位',
  message51: '无效关联',
  message52: '附件上传',
  message53: '外部培训费用超过 4000 元需签订培训服务协议',
  message54:
    '服务期约定：外部培训费用超过4000元需签订培训服务协议，培训完成后需提交培训总结！',
  optionMenu1: '修改密码',
  optionMenu2: '绑定设备',
  optionMenu3: '通知方式',
  optionMenu4: '代理设置',
  optionMenu5: '背景设置',
  staffMenu1: '我的档案',
  staffMenu2: '考勤数据',
  staffMenu3: '薪资数据',
  helpMenu1: '点击登录失败',
  helpMenu2: '重置密码失败？',
  helpMenu201: '子菜单',
  helpMenu202: '子菜单',
  helpMenu203: '子菜单',
  helpMenu3: '系统功能介绍',
  router01: '首页',
  router02: '员工信息',
  router03: '汇报关系',
  router04: '审批中心',
  router05: '福利中心',
  router06: '报表中心',
  router07: '人事管理',
  router08: '系统管理',
  router09: '组织架构',
  router10: '人事审批',
  router11: '考勤审批',
  router12: '行政审批',
  router13: '其他',
  router14: '岗位申请',
  router15: '招聘',
  router16: '转正',
  router17: '调岗',
  router18: '合同签署',
  router19: '奖金津贴',
  router20: '调薪',
  router21: '调岗',
  router22: '合同签署',
  router23: '奖金津贴',
  router24: '财务审批',
  router25: '数据中心',
  router26: '借支',
  router27: '岗位申请预算外',
  router28: '员工培训',
  router29: '时间配额延期',
  router30: '员工发展',
  router31: '办公设备维修',
  router32: '请购单',
  router33: '报销单',
  router34: '公章使用登记',
  router35: '刻章申请',
  router36: '销假',
  homelist01: '企业罗盘',
  homelist02: '欢迎加入',
  homelist03: '新员工',
  homelist04: '汇报关系',
  homelist05: '组织架构',
  homelist06: '人才罗盘',
  homelist07: '我的需求',
  homelist08: '我的待办',
  homelist09: '审批中心',
  homelist10: '时间配额',
  homelist11: '我的考勤',
  homelist12: '考勤专员室',
  homelist13: '我的工资',
  homelist14: '大数据分析',
  homelist15: '人事管理',
  homelist16: '系统管理',
  homelist17: '生日员工',
  homelist18: '核心人事',
  dataCenter01: '员工分析',
  dataCenter02: '组织列表',
  dataCenter03: '入职状态',
  dataCenter04: '岗位列表',
  dataCenter05: '岗位分配',
  dataCenter06: '加班分析',
  dataCenter07: '时间评估结果',
  dataCenter08: '员工工资',
  dataCenter09: '十二万税报',
  dataCenter10: '收入证明',
  dataCenter11: '离职证明',
  dataCenter12: '用户日志',
  dataCenter13: '日志记录',
  guideTitle1: '一、Logo',
  guideTitle2: '二、主菜单',
  guideTitle3: '三、搜索框',
  guideTitle4: '四、用户菜单',
  guideTitle5: '五、用户信息',
  guideTitle6: '六、我的消息',
  guideTitle7: '七、我的应用',
  guideContent1: '点击Logo回到首页',
  guideContent2: '点击打开系统主菜单',
  guideContent3: '输入正确姓名搜索员工',
  guideContent4: '点击打开用户菜单',
  guideContent5: '点击查看员工详细信息',
  guideContent6: '点击查看所有消息',
  guideContent7: '点击显示/隐藏应用菜单',
  guideButton1: '下一步',
  guideButton2: '完成',
  pmMenu01: '在线咨询',
  pmMenu02: '自助管理',
  pmMenu03: '入职管理',
  pmMenu04: '员工档案',
  pmMenu05: '组织管理',
  pmMenu06: '时间管理',
  pmMenu07: '薪资管理',
  pmMenu08: 'OKR工作坊',
  pmMenu09: '预算管理',
  pmMenu10: '调薪',
  tableTitle01: '基本信息',
  tableTitle02: '组织关系',
  tableTitle03: '地址',
  tableTitle04: '支付信息',
  tableTitle05: '家庭成员',
  tableTitle06: '合同',
  tableTitle07: '学历',
  tableTitle08: '前雇主',
  tableTitle09: '职称技能',
  tableTitle10: '奖惩记录',
  tableTitle11: '日期',
  tableTitle12: '发展项目',
  tableTitle13: '借款借物',
  tableTitle14: '伙伴',
  tableTitle15: '交通工具',
  tableTitle16: '语言能力',
  tableTitle17: '数据状态',
  tableTitle18: '工作计划',
  tableTitle19: '调班',
  tableTitle20: '补打卡',
  tableTitle21: '请假',
  tableTitle22: '加班',
  tableTitle23: '时间配额',
  tableTitle24: '时间薪资项',
  tableTitle25: '基本工资',
  tableTitle26: '周期薪资项',
  tableTitle27: '临时薪资项',
  tableTitle28: '班车',
  tableTitle29: '工作餐',
  tableTitle30: '用车',
  tableTitle31: '物品领用',
  tableTitle32: '用印',
  tableTitle33: '报销',
  tableTitle34: '付款',
  tableTitle35: '采购',
  tableTitle36: '合同审批',
  tableTitle37: '立项',
  tableTitle38: '出勤',
  tableTitle39: '出勤异常',
  tableTitle40: '外出',
  tableTitle41: '出差',
  tableTitle42: '地点',
  tableTitle43: '行政采购',
  PA01: '基本信息',
  PA02: '组织管理',
  PA03: '地址',
  PA04: '支付信息',
  PA05: '家庭成员',
  PA06: '合同',
  PA07: '学历',
  PA08: '前雇主',
  PA09: '职称技能',
  PA10: '奖惩记录',
  PA11: '日期',
  PA12: '发展项目',
  PA13: '借款借物',
  PA14: '伙伴',
  PA15: '交通工具',
  PA16: '语言能力',
  TM01: '工作计划',
  PY02: '基本工资',
  PY03: '周期薪资',
  PY04: '临时薪资',
  list01: '基本信息',
  list02: '组织管理',
  list03: '地址',
  list04: '支付信息',
  list05: '家庭成员',
  list06: '合同',
  list07: '学历',
  list08: '前雇主',
  list09: '职称技能',
  list10: '奖惩记录',
  list11: '日期',
  list12: '发展项目',
  list13: '借款借物',
  list14: '伙伴',
  list15: '交通工具',
  list16: '语言能力',
  list17: '数据状态',
  list18: '工作计划',
  list19: '基本工资',
  list20: '周期薪资',
  list21: '临时薪资',
  list22: '拖动滑块验证',
  list23: '时间配额',
  list24: '时间薪资',
  list25: '上传附件',
  list26: '员工',
  list27: '当前日期',
  list28: '打卡位置',
  list29: '上岗打卡',
  list30: '离岗打卡',
  list31: '上岗打卡',
  list32: '离岗打卡',
  list33: '打卡时间',
  list34: '打卡类型',
  list35: '未打卡',
  list36: '主管岗位',
  list37: '添加',
  list38: '上车时间',
  list39: '渠道',
  list40: '详情',
  list41: '动作',
  list42: '用户名',
  list43: '日期区间',
  list44: '信心指数',
  list45: '分数',
  list46: '内容',
  list47: 'KR详情',
  list48: '协助人',
  list49: '任务清单',
  list50: 'OKR详情',
  list51: '招商银行',
  list52: '支付宝',
  list53: '微信支付',
  list54: '线下支付',
  loading: '玩命加载中...',
  model01: '名称',
  model02: '公司',
  model03: '成本中心',
  model04: '工作地',
  model05: '开始时间',
  model06: '结束时间',
  model07: '组织类别',
  model08: '上级组织',
  model09: '组织',
  model10: '岗位',
  model11: '职级',
  model12: '关键职位',
  model13: '虚线汇报',
  model14: '主管',
  model15: '是',
  model16: '否',
  model17: '类别',
  model18: '主管',
  model19: '分配',
  model20: '查找',
  model21: '员工',
  model22: '上级组织',
  model23: '数据',
  model24: '截断',
  model25: '移动',
  entry01: '入职日期',
  entry02: '附件',
  entry03: '状态',
  entry04: '处理人',
  entry05: '提交者',
  entry06: '满意调查',
  entry07: '入职',
  entry08: '全部',
  entry09: '处理日期',
  entry10: '入职',
  open: '展开',
  reOpen: '收起',
  index01: '年',
  index02: '月',
  index03: '班次',
  index04: '日',
  index05: '一',
  index06: '二',
  index07: '三',
  index08: '四',
  index09: '五',
  index10: '六',
  index11: '元旦节',
  index12: '春节',
  index13: '清明节',
  index14: '劳动节',
  index15: '端午节',
  index16: '中秋节',
  index17: '国庆节',
  filter01: '试用期',
  filter02: '在职',
  filter03: '待岗',
  diver01: '第',
  diver02: '条数据',
  new01: '没有附件！',
  new02: '面试中心',
  new03: '住址',
  new04: '请输入性别',
  new05: '您是否要在提交数据后再退出！',
  new06: '有必填信息没有输入，是否放弃提交？',
  new07: '成员姓名',
  new08: '请输入成员姓名',
  new09: '放弃提交',
  new10: '暂无附件',
  new11: '实名认证无法拒绝！',
  new12: '合同签署无法拒绝！',
  new13: '审批详情',
  new14: '点击查看详情',
  new15: '支付方式',
  new16: '请选择正确的缴费类型',
  new17: '缴纳地',
  new18: '请选择正确的缴纳地',
  new19: '基数',
  new20: '请输入正确的基数',
  new21: '比例',
  new22: '请输入比例（%）',
  new23: '社保账号',
  new24: '请输入社保账号',
  new25: '公积金账户',
  new26: '请输入公积金账号',
  new27: '总收入',
  new28: '国家政策',
  new29: '正常支付',
  new30: '员工支付',
  new31: '公司支付',
  new32: '不支付',
  new33: '印染项目',
  new34: '创建合同',
  new35: '关联项目',
  new36: '客户',
  new37: '养老保险',
  new38: '医疗保险',
  new39: '生育保险',
  new40: '失业保险',
  new41: '默认账户',
  new42: '时间状态',
  new43: '算薪过滤',
  new44: '错误清单',
  new45: '终止',
  new46: '执行人',
  new47: '支付',
  new48: '类型',
  new49: '试跑',
  new50: '员工清单',
  new51: '错误清单',
  new52: '试跑结果不保存到数据库！',
  new53: '试跑结果不保存到数据库，仅供正式算薪前的确认。',
  new54: '结束流程',
  new55: '重启流程',
  new56: '实付工资',
  new57: '应付工资',
  new58: '错误',
  new59: '支付类型',
  new60: '缴费方式',
  new61: '请至少选择一项！',
  new62: '个税',
  new63: '预计离职日期',
  new64: '离职原因备注',
  new65: '工作交接人',
  new66: '工作交接事项',
  new67: '你对目前部门的建议',
  new68: '你对公司建议',
  new69: '交接内容',
  new70: '交接人员',
  new71: '第一个月',
  new72: '第二个月',
  new73: '第三个月',
  new74: '第四个月',
  new75: '第五个月',
  new76: '第六个月',
  new77: '平均',
  new78: '试用期内自评',
  new79: '试用期总结报告',
  new80: '个人工作发展报告',
  new81: '运行中',
  new82: '工资单',
  new83: '住房公积金',
  new84: '重新计算薪资',
  new85: '缴费地区',
  new86: '系统异常',
  new87: '系统错误，请联系管理员！',
  new88: '网银数据',
  new89: '编号',
  new90: '执行时间',
  new91: '评估结果',
  new92: '任务名称',
  new93: '评估开始日期',
  new94: '评估结束日期',
  new95: '评估',
  new96: '评估结果',
  new97: '原始数据',
  new98: '支付结果',
  new99: '薪资原数据',
  new100: '导入',
  new101: '发放',
  new102: '任务',
  new103: '数据类型',
  new104: '申请人工号',
  new105: '申请人姓名',
  new106: '薪资支付月份',
  new107: '支付笔数',
  new108: '支付总金额',
  new109: '已支付',
  new110: '未支付',
  new111: '未申请',
  new112: '待支付',
  new113: '支付成功',
  new114: '支付失败',
  new115: '申请支付',
  new116: '签约状态',
  new117: '授权状态',
  new118: '修改人',
  new119: '修改时间',
  new120: '签约',
  new121: '授权',
  new122: '支付宝',
  new123: '微信',
  new124: '平均工资',
  new125: '汇总数',
  new126: '13薪',
  new127: '离职补偿金',
  new128: '赔偿倍率',
  new129: '工作年限',
  new130: '地区职工平均工资',
  new131: '覆盖',
  new132: '生成网银文件',
  new133: '应用到社会保险和住房公积金',
  new134: '选择文件',
  new135: '覆盖原数据',
  new136: '下载模板',
  new137: '出勤评估单',
  new138: '添加签署文件',
  new139: '骑缝章',
  new140: '招商银行支付协议',
  new141: '支付协议',
  new142: '请点击该链接进行',
  new143: '三方应用授权',
  new144: '商户签约',
  new145: '中介费',
  new146: '养老保险（单位）',
  new147: '医疗保险（单位）',
  new148: '大病保险（单位）',
  new149: '生育保险（单位）',
  new150: '失业保险（单位）',
  new151: '住房公积金（单位）',
  new152: '个税（单位）',
  new153: '总成本',
  new154: '公积金(个人)',
  new155: '公积金统筹(个人)',
  new156: '大病保险(个人)',
  new157: '生育保险(个人)',
  new158: '医疗保险(个人)',
  new159: '失业保险(个人)',
  new160: '养老保险(个人)',
  new161: '社保统筹(个人)',
  new162: '合计(个人)',
  new163: '公积金(单位)',
  new164: '公积金统筹(单位)',
  new165: '大病保险(单位)',
  new166: '工伤保险(单位)',
  new167: '生育保险(单位)',
  new168: '医疗保险(单位)',
  new169: '养老保险(单位)',
  new170: '失业保险(单位)',
  new171: '社保统筹(单位)',
  new172: '合计(单位)',
  new173: '上月金额',
  new174: '差额',
  new175: '应出勤天数',
  new176: '实际出勤天数',
  new177: '应出勤小时数',
  new178: '实际出勤小时数',
  new179: '年度',
  new180: '开始月份',
  new181: '结束月份',
  new182: '维度',
  new183: '方式',
  new184: '包含子组织',
  new185: '工资清单',
  new186: '方案',
  new187: '年度',
  new188: '薪资项',
  new189: '工资总额（元）',
  new190: '调薪比例（%）',
  new191: '预算总额',
  new192: '细化级别',
  new193: '类别',
  new194: '全年预算',
  new195: '提示',
  new196: '强制',
  new197: '组织列表',
  new198: '成本中心',
  new199: '调薪矩阵',
  new200: '月度预算',
  new201: '上一步',
  new202: '生成方案',
  new203: '方案详情',
  new204: '开启',
  new205: '停用',
  new206: '调后金额（元）',
  new207: '预算总额（元）',
  new209: '入职管理逐个审批',
  new210: '文件大小不能超过',
  new211: '维度',
  new212: '员工列表',
  new213: '上月实付',
  new214: '入职日',
  new215: '离职日',
  new216: '基数请取自范围：',
  new217: '过滤离职人员',
  new218: '成功',
  new219: '工作年限分析',
  new220: '人数',
  new221: '请输入关键字',
  new222: '经纬度',
  new223: '地点',
  new224: '请选择地点',
  new225: '报销费',
  new226: '培训费',
  new227: '公积金统筹（单位）',
  new228: '手机',
  new229: '电脑',
  new300: '加班时数',
  new301: '请假时数',
  new302: '旷工时数',
  new303: '迟到时数',
  new304: '早退时数',
  new305: '事假时数',
  new306: '病假时数',
  new307: '补充养老保险',
  new308: '补充医疗保险',
  new309: '补充比例',
  new310: '支付中',
  new311: '支付检查',
  new312: '账号或账户名称没有设置',
  new313: '点击确定过滤报错员工发起支付申请',
  new314: '平均转正月',
  new315: '转正率',
  new316: '添加地点',
  new317: '请提交真实的个人数据，公司有权对您提交的虚假数据追究相应的责任！',
  new318: '的',
  new319: '没有可保存的数据',
  new320: '催办成功，请静候消息！',
  new321: '访客管理',
  new322: '实名认证完成',
  new323: '默认隐藏已审批过的需求，点击状态列过滤图标可恢复显示！',
  new324: '离职申请日期',
  new325: '计划离职日期',
  new326: '离职生效日期',
  brain01: '职级分析',
  brain02: '员工流动分析',
  brain03: '薪资分析',
  brain04: '请假、加班人数',
  brain05: '岗位分析',
  brain06: '招聘渠道分析',
  brain07: '应付统计',
  brain08: '员工转正分析',
  brain09: '工作负荷分析',
  AwardImportName: 'award',
  BonusesImportName: '奖金津贴模板',
  PayRaiseImportName: 'pay_raise',
  attendancePaidSick: '带薪病假',
  attendanceAnnualLeave: '年假',
  attendanceOtherLeave: '其它假别',
  attendanceNightShift: '夜班',
  entryQr: '入职二维码',
  entryQrTip: '扫码提交入职资料',
  workBadgeTitle: '工牌预览',
  workBadgeTooltip: '生成工牌',
  workBadgePreviewOnly: '本人仅可预览，不可下载',
  workBadgeBatchDone: '工牌已全部保存至所选目录',
  workBadgeBatchZipDone: '工牌已打包为 ZIP 文件下载',
  workBadgeGenerateFailed: '工牌生成失败，请稍后重试',
  workBadgeNoPhoto: '暂无照片',
  workBadgeDownloadScope: '白色卡片区域即为下载后的工牌范围',
  adminItemId: '编号',
  adminItemName: '名称',
  adminItemType: '类型',
  adminItemQuantity: '数量',
  adminItemUnit: '单位',
  adminItemBrand: '品牌',
  adminItemModel: '型号',
  adminItemCode: '编码',
  adminItemMaterial: '材质',
  adminItemColor: '颜色',
  adminItemSize: '尺寸',
  adminItemSafetyStock: '安全库存',
  adminItemAttachment: '附件',
  adminItemTitle: '行政物品',
  adminItemAdd: '新增行政物品',
  adminItemEdit: '修改行政物品',
  adminItemQuantityTip: '请输入正确数量（最多一位小数）',
  placeholderAdminItemName: '请输入名称',
  placeholderAdminItemType: '请选择类型',
  placeholderAdminItemQuantity: '请输入数量',
  placeholderAdminItemUnit: '请输入单位',
  placeholderAdminItemBrand: '请输入品牌',
  placeholderAdminItemModel: '请输入型号',
  placeholderAdminItemCode: '请输入编码',
  placeholderAdminItemMaterial: '请输入材质',
  placeholderAdminItemColor: '请输入颜色',
  placeholderAdminItemSize: '请输入尺寸',
  placeholderAdminItemSafetyStock: '请输入安全库存',
  placeholderAdminItemAttachment: '请输入附件',
  // 柜子管理
  adminCabinetTitle: '柜子管理',
  adminCabinetAdd: '新增柜子',
  adminCabinetEdit: '修改柜子',
  adminCabinetSerialNo: '编号',
  adminCabinetName: '名称',
  adminCabinetType: '类型',
  adminCabinetLayers: '层数',
  adminCabinetColumns: '列数',
  adminCabinetLocation: '位置',
  adminCabinetUsedGrids: '已用格数',
  adminCabinetSafetyGrids: '安全格数',
  adminCabinetBrand: '品牌',
  adminCabinetModel: '型号',
  adminCabinetCode: '编码',
  adminCabinetMaterial: '材质',
  adminCabinetColor: '颜色',
  adminCabinetEstablishmentDate: '设立时间',
  adminCabinetStatus: '状态',
  adminCabinetAttachment: '附件',
  adminCabinetIntegerTip: '请输入整数',
  placeholderAdminCabinetSerialNo: '请输入编号',
  placeholderAdminCabinetName: '请输入名称',
  placeholderAdminCabinetType: '请选择类型',
  placeholderAdminCabinetLayers: '请输入层数',
  placeholderAdminCabinetColumns: '请输入列数',
  placeholderAdminCabinetLocation: '请输入位置',
  placeholderAdminCabinetSafetyGrids: '请输入安全格数',
  placeholderAdminCabinetBrand: '请输入品牌',
  placeholderAdminCabinetModel: '请输入型号',
  placeholderAdminCabinetCode: '请输入编码',
  placeholderAdminCabinetMaterial: '请输入材质',
  placeholderAdminCabinetColor: '请输入颜色',
  placeholderAdminCabinetEstablishmentDate: '请选择设立时间',
  placeholderAdminCabinetStatus: '请选择状态',
  cabinetStatusUsed: '已占用',
  cabinetStatusFree: '空闲中',
  cabinetStatusBroken: '已损坏',
  // 车辆管理
  adminVehicleTitle: '车辆管理',
  adminVehicleAdd: '新增车辆',
  adminVehicleEdit: '修改车辆',
  adminVehicleSerialNo: '编号',
  adminVehicleVehicle: '车辆',
  adminVehicleApplyer: '申请人',
  adminVehicleDepartureTime: '出发时间',
  adminVehicleReturnTime: '归还时间',
  adminVehicleRequestId: '申请单',
  adminVehicleRemark: '备注',
  adminVehicleUseTime: '使用时间',
  placeholderAdminVehicleVehicle: '请选择车辆',
  placeholderAdminVehicleApplyer: '请选择申请人',
  placeholderAdminVehicleDepartureTime: '请选择出发时间',
  placeholderAdminVehicleReturnTime: '请选择归还时间',
  placeholderAdminVehicleRequestId: '请输入申请单号',
  placeholderAdminVehicleRemark: '请输入备注',
  placeholderStartTime: '开始时间',
  placeholderEndTime: '结束时间',
  // 物品出入库
  itemStockTitle: '物品出入库',
  itemStockSerialNo: '编号',
  itemStockName: '名称',
  itemStockType: '类型',
  itemStockActionType: '操作类型',
  itemStockActionTime: '操作时间',
  itemStockQuantity: '数量',
  itemStockUnit: '单位',
  itemStockReason: '事由',
  itemStockOrderNo: '订单号',
  itemStockAmount: '金额（元）',
  itemStockRemark: '备注',
  itemStockAttachment: '附件',
  itemStockIn: '入库',
  itemStockOut: '出库',
  itemStockInTime: '入库时间',
  itemStockOutTime: '出库时间',
  itemStockItem: '物品',
  purchasingItem: '采购物品',
  placeholderItemStockSerialNo: '请输入编号',
  placeholderItemStockName: '请输入名称',
  placeholderItemStockActionType: '请选择操作类型',
  placeholderItemStockDateRange: '请选择操作时间范围',
  placeholderItemStockItem: '请选择物品',
  placeholderPurchasingItem: '请选择采购物品',
  placeholderItemStockTime: '请选择时间',
  placeholderItemStockQuantity: '请输入数量',
  placeholderItemStockReason: '请输入事由',
  placeholderItemStockOrderNo: '请输入订单号',
  placeholderItemStockAmount: '请输入金额',
  placeholderItemStockRemark: '请输入备注',
  itemStockInsufficient: '库存不足',
  // 柜子分配总览
  adminOverviewTitle: '系统总览',
  totalWardrobe: '总衣柜数',
  totalShoeCabinet: '总鞋柜数',
  totalDormitory: '宿舍总数',
  totalOccupancy: '入住总人数',
  unitBuilding: '栋',
  unitPerson: '人',
  comparedToLastMonth: '较上月',
  occupancyRate: '入住率',
  allocated: '已分配',
  pendingAllocation: '待分配',
  // 柜子分配表格
  cabinetEmpName: '员工姓名',
  cabinetEmpNo: '工号',
  cabinetDept: '部门',
  cabinetType: '柜子类型',
  cabinetNo: '编号',
  cabinetTime: '分配时间',
  cabinetStatus: '状态',
  recentAllocationRecord: '最近分配记录',
  viewAll: '查看全部',
  // 柜子分配列表
  cabinetAllocationTitle: '柜子分配',
  cabinetAllocationSerialNo: '编号',
  cabinetAllocationName: '名称',
  cabinetAllocationType: '类型',
  cabinetAllocationEmp: '员工',
  cabinetAllocationEmpCoding: '工号',
  cabinetAllocationEmpName: '姓名',
  cabinetAllocationLayerNo: '层号',
  cabinetAllocationColumnNo: '列号',
  cabinetAllocationTime: '分配时间',
  cabinetAllocationReason: '事由',
  cabinetAllocationOrderNo: '需求编号',
  cabinetAllocationRemark: '备注',
  cabinetAllocationAttachment: '附件',
  cabinetAllocation: '分配',
  cabinetCancel: '取消',
  confirmCancelAllocation: '您确定要取消分配吗？',
  placeholderCabinetAllocationSerialNo: '请输入编号',
  placeholderCabinetAllocationName: '请输入名称',
  placeholderCabinetAllocationType: '请选择类型',
  placeholderCabinetAllocationEmp: '请选择员工',
  placeholderCabinetAllocationEmpCoding: '请输入工号',
  placeholderCabinetAllocationEmpName: '请输入姓名',
  placeholderCabinetAllocationLayerNo: '请输入层号',
  placeholderCabinetAllocationColumnNo: '请输入列号',
  placeholderCabinetAllocationTime: '请选择分配时间',
  placeholderCabinetAllocationReason: '请输入事由',
  placeholderCabinetAllocationOrderNo: '请输入需求编号',
  placeholderCabinetAllocationRemark: '请输入备注',
  // 柜子申请
  cabinetApplyTitle: '柜子申请',
  applyDate: '申请日期',
  applyReason: '申请原因',
  placeholderApplyDate: '请选择申请日期',
  placeholderApplyReason: '请输入申请原因',
  placeholderCabinetType: '请选择柜子类型',
  placeholderPhone: '请输入电话',
  cabinetAllocateSuccess: '分配成功',
  // 销柜
  cabinetCancelTitle: '销柜',
  cabinetLabel: '柜子',
  cabinetCancelDate: '销柜日期',
  cabinetCancelReason: '销柜原因',
  placeholderCabinetSelect: '请选择柜子',
  placeholderCabinetCancelDate: '请选择销柜日期',
  placeholderCabinetCancelReason: '请输入销柜原因',
  // 借款
  borrowPayFieldAmount: '金额',
  borrowPayAmountInWords: '大写金额',
  borrowPayFieldCurrency: '币种',
  borrowPayAmountTip: '请填写正确的金额（最多一位小数）',
  borrowPayAttachmentTip: '请在出发前5天内将汇款单提交至会计部门',
  // 报修
  repairTitle: '报修',
  repairEmpId: '工号',
  repairEmpName: '姓名',
  repairJobName: '岗位',
  repairOrgName: '部门',
  repairPhone: '电话',
  repairType: '报修类别',
  repairAddress: '报修地点',
  repairFaultDescription: '故障现象描述',
  placeholderRepairPhone: '请输入电话',
  placeholderRepairType: '请选择报修类别',
  placeholderRepairAddress: '请输入报修地点',
  placeholderRepairFaultDescription: '请输入故障现象描述',
  repairTypeFetchFailed: '获取报修类型失败',
  // 礼品招待申请
  titleGiftHospitality: '礼品招待申请',
  formBudgetAmount: '预算金额',
  formApplyAmount: '申请金额',
  formLoanOrder: '借款单',
  placeholderGiftContent: '请输入申请内容',
  placeholderGiftQuantity: '请输入数量',
  placeholderBudgetAmount: '请输入预算金额',
  placeholderApplyAmount: '请输入申请金额',
  placeholderValidNumber: '请输入正确的数字',
  placeholderValidAmount: '请输入正确的金额',
  placeholderGiftReason: '请输入申请事由',
  placeholderLoanOrder: '请选择借款单',
  // Stantauto 定制工作餐
  dinnerStantautoTitle: '工作餐',
  dinnerTime: '时间',
  dinnerPeopleNum: '人数',
  dinnerMealType: '餐次',
  dinnerCopies: '份数',
  dinnerMealLunch: '午餐',
  dinnerMealDinner: '晚餐',
  placeholderDinnerTime: '请选择时间',
  placeholderDinnerPeopleNum: '请输入人数，需大于0',
  placeholderDinnerMealType: '请选择餐次',
  placeholderDinnerCopies: '请输入份数',
  placeholderOrgName: '请输入部门',
  // 预算管理
  adminBudgetTitle: '预算管理',
  adminBudgetAdd: '新增预算',
  adminBudgetEdit: '修改预算',
  adminBudgetSerialNo: '编号',
  adminBudgetYear: '年份',
  adminBudgetDept: '部门',
  adminBudgetCostItem: '费用名称',
  adminBudgetCostItemType: '费用类型',
  adminBudgetJan: '1月',
  adminBudgetFeb: '2月',
  adminBudgetMar: '3月',
  adminBudgetApr: '4月',
  adminBudgetMay: '5月',
  adminBudgetJun: '6月',
  adminBudgetJul: '7月',
  adminBudgetAug: '8月',
  adminBudgetSep: '9月',
  adminBudgetOct: '10月',
  adminBudgetNov: '11月',
  adminBudgetDec: '12月',
  adminBudgetTotal: '年度预算合计',
  adminBudgetRemark: '备注',
  placeholderAdminBudgetYear: '请输入年份',
  placeholderAdminBudgetDept: '请选择部门',
  placeholderAdminBudgetCostItem: '请选择费用名称',
  placeholderAdminBudgetCostItemType: '费用类型自动带出',
  placeholderAdminBudgetMonth: '请输入预算',
  placeholderAdminBudgetTotal: '请输入年度预算合计',
  placeholderAdminBudgetRemark: '请输入备注',
  placeholderAdminBudgetSerialNo: '请输入编号',
  adminBudgetYearTip: '请输入正确的年份格式（如：2026）',
  // 费用管理
  adminCostTitle: '费用管理',
  adminCostAdd: '新增费用',
  adminCostEdit: '修改费用',
  adminCostSerialNo: '编号',
  adminCostDept: '部门',
  adminCostCostItem: '费用名称',
  adminCostCostItemType: '费用类型',
  adminCostAmount: '费用金额',
  adminCostDate: '日期',
  adminCostRemark: '备注',
  adminCostYear: '年份',
  placeholderAdminCostSerialNo: '请输入编号',
  placeholderAdminCostDept: '请选择部门',
  placeholderAdminCostCostItem: '请选择费用名称',
  placeholderAdminCostCostItemType: '费用类型自动带出',
  placeholderAdminCostAmount: '请输入费用金额，最多一位小数',
  placeholderAdminCostDate: '请选择日期',
  placeholderAdminCostRemark: '请输入备注',
  placeholderAdminCostYear: '请输入年份',
  adminCostAmountTip: '请输入有效的数字，最多一位小数',
  // 用车
  peopleCount: '人数',
  companions: '同行人',
  vehicleType: '需要车辆',
  fromLocation: '出发地',
  toLocation: '到达地',
  distance: '预计公里数',
  startTime: '出发时间',
  returnTime: '预计返回时间',
  placeholderPeopleCount: '请输入人数，需大于0',
  placeholderPeopleCountInvalid: '请输入大于0的整数',
  placeholderCompanions: '请输入同行人',
  placeholderFromLocation: '请从地图上选择出发地',
  placeholderToLocation: '请从地图上选择到达地',
  placeholderDistance: '请输入预计公里数',
  placeholderDistanceInvalid: '请输入有效的数字，最多一位小数',
  // stantauto 报销（request_rel_id 仍为 reimbursement_changhuo）
  reimburseStantautoInvolvedCities: '涉及城市',
  reimburseStantautoExchangeRate: '汇率',
  reimburseStantautoExchangeRateTip: '最多六位小数',
  reimburseStantautoBusinessTrip: '出差单',
  reimburseStantautoAccounting: '会计科目',
  reimburseStantautoDirectSettlement: '直接结算',
  reimburseStantautoGrandTotal: '总合计',
  reimburseStantautoPrepayAmount: '预借款金额',
  reimburseStantautoPayableAmount: '应付金额',
  reimburseStantautoDateRow: '日期',
  reimburseStantautoSelectDate: '请选择日期',
  reimburseStantautoEnterAmount: '请输入金额',
  reimburseStantautoRowAmount: '金额',
  reimburseStantautoAddDateCol: '增加日期列',
  reimburseStantautoRemoveDateCol: '减少日期列',
  reimburseStantautoNoInvoiceConfirm: '当前未上传发票附件，是否仍要提交？',
  reimburseStantautoDuplicateInvoice: '发票号码 {no} 已存在（重复），请核对后再上传',
  reimburseStantautoInvoiceRecognizing: '发票识别中，请稍候再提交',
  reimburseStantautoSelectBusinessTrip: '请选择出差单',
  reimburseStantautoMatrixDateRequired: '请为已填写金额的日期列选择日期',
  reimburseStantautoMatrixAccountRequired: '请为已填写金额的报销行选择会计科目',
  reimburseStantautoSensitive: '含敏感词发票',
  reimburseStantautoNoInvoiceTag: '没有发票',
  // 行政管理总览
  itemStockWarning: '物品库存预警',
  cabinetAllocationStatus: '柜子分配状态',
  preActualAnalysis: '预实分析',
  costAnalysis: '费用分析',
  vehicleInUse: '在用车辆',
  vehicleNumber: '编号',
  vehicleName: '车辆',
  vehicleApplicant: '申请人',
  vehicleDepartureTime: '出发时间',
  vehicleReturnTime: '归还时间',
  totalGrids: '总格数',
  usedGrids: '已用格数',
  safetyGrids: '安全格数',
  budgetAmount: '预算',
  actualAmount: '实际支出',
  selectYear: '选择年份',
  dimension: '维度',
  dimensionDept: '部门',
  dimensionCostType: '费用类型',
  dimensionCostItem: '费用名称',
  preActualBarTitle: '预算与实际费用对比',
  costMonthCompare: '年度内各月份实际支出费用金额与去年对比',
  costDeptCompare: '年度内各部门实际支出费用金额与去年对比',
  costItemCompare: '年度内各费用实际支出费用金额与去年对比',
  costGrowthUp: '较上年↑',
  costGrowthDown: '较上年↓',
  annualBudget: '年度预算',
  annualActualExpense: '年度实际支出',
  remainingBudget: '剩余预算',
  budgetUsageRate: '年度预算使用率',
  currentYearAmount: '本年度金额',
  lastYearAmount: '上一年度金额',
  ...zhCN,
};

export default cn;
